<template>
    <div id="Sales_Settings_Header">
        <!-- <div class="FilterContainer">
            <div class="FilterTitle">輸入日</div>
                <div class="row mt-1 border" v-show="show.calendar">
                    <DatePicker
                        v-model:="SelectedFilterDate"
                        @onSelect="UpdatedFilterDate"
                        :next-prev-icon="true"
                        :last-month="todayDt"
                        :first-month="firstDt"
                        :enable-second-calendar="true"
                    />
                </div>
                <div id='DatePicker' class="FilterElement RoundShadowElement" @click="ShowCalendar()">{{ SelectedFilterDate[0].format("MMM, YYYY") }} - {{ SelectedFilterDate[1].format("MMM, YYYY") }}</div>
        </div> -->
        <div class="FilterContainer" style="margin-top: -15px; margin-left: 25px;">
            <div class="FilterTitle">年</div>
            <div>
                <VueSlider v-model="FilterYear" :min="MinFilterYear" :max="MaxFilterYear" :maxRange="MaxFilterYear" marks @drag-end="OnFilterYearChange" />
            </div>
        </div>
        <div class="FilterContainer" style="margin-top: -15px; margin-left: 45px;" v-if="FilterYear[0]===FilterYear[1]">
            <div class="FilterTitle">月</div>
            <div>
                <VueSlider v-model="FilterMonth" :min="1" :max="12" marks @drag-end="OnFilterMonthChange" />
            </div>
        </div>
    </div>

    <div style="padding-left: 25px; padding-right: 10%; padding-top: 20px;">
        <div>
            <div>
                <span :title="CurrentMonth">{{ CurrentYear }} 年売上: ¥ {{ CurrentYearSales }}</span>
            </div>
            <div id="TotalSalesBarContainer" style="width: 100%; height: 25px;">
                <div id="TotalSalesBar" style="display: grid; align-content: center; text-align: right; width: 0%; height: 25px; background-color: rgba(135,190,177,1); transition: 0.5s; -webkit-transition: 0.5s; -moz-transition: 0.5s;">
                    <span id="TotalSalesPercentage" style="margin-right: 20px; color: white;"></span>
                </div>
            </div>
            <div style="margin-top: 10px;">
                <span :title="CurrentMonth">{{ CurrentYear }} 年利益: ¥ {{ CurrentYearProfit }}</span>
            </div>
            <div id="TotalProfitBarContainer" style="width: 100%; height: 25px;">
                <div id="TotalProfitBar" style="display: grid; align-content: center; text-align: right; width: 0%; height: 25px; background-color: rgba(135,190,177,1); transition: 0.5s; -webkit-transition: 0.5s; -moz-transition: 0.5s;">
                    <div id="TotalProfitPercentage" style="margin-right: 20px; color: white;"></div>
                </div>
            </div>
        </div>
    </div>

    <div class="Separator"></div>
    <div class="ChartTabs" style="padding-left: 45px;">
        <GenericDropdown :elementID="'PieChart_SeriesSelector'" :options="PieChart_TotalCostOptions" :OnChange="OnTotalCostPieChartChange" />
    </div>
    <div v-if="PieChart_SelectedTotalCostComparison === 0" id="PieChart_Total_Series">
        <div class="ChartContainer">
            <div class="ChartWrapper" id="PieChart_Total_Series_Main">
                <VuePlotly :data="PieChart_SeriesTotalData" :layout="PieChart_SeriesTotalLayout" :config="config" />
                <!-- KEEP THIS FOR REFERENCE WHEN NEEDED
                <div class="pie">
                    <svg id="PieTest">
                    </svg>
                </div>
                <div class="PieLegend">
                    <ul id="PieTestLegend">

                    </ul>
                </div> -->
            </div>
        </div>
        <div class="ChartContainer">
            <div class="ChartWrapper" id="PieChart_Total_Series_Sub">
                <VuePlotly :data="PieChart_SeriesData" :layout="PieChart_SeriesLayout" :config="config" />
            </div>
        </div>
    </div>
    <div v-if="PieChart_SelectedTotalCostComparison === 1" id="PieChart_Total_Brand">
        <div class="ChartContainer">
            <div class="ChartWrapper" id="PieChart_Total_Brand_Main">
                <VuePlotly :data="PieChart_BrandTotalData" :layout="PieChart_BrandTotalLayout" :config="config" />
            </div>
        </div>
        <div class="ChartContainer">
            <div class="ChartWrapper" id="PieChart_Total_Brand_Sub">
                <VuePlotly :data="PieChart_BrandData" :layout="PieChart_BrandLayout" :config="config" />
            </div>
        </div>
    </div>
    <div v-if="PieChart_SelectedTotalCostComparison === 2" id="PieChart_Total_Factory">
        <div class="ChartContainer">
            <div class="ChartWrapper" id="PieChart_Total_Factory_Main">
                <VuePlotly :data="PieChart_FactoryTotalData" :layout="PieChart_FactoryTotalLayout" :config="config" />
            </div>
        </div>
        <div class="ChartContainer">
            <div class="ChartWrapper" id="PieChart_Total_Factory_Sub">
                <VuePlotly :data="PieChart_FactoryData" :layout="PieChart_FactoryLayout" :config="config" />
            </div>
        </div>
    </div>
    <div class="Separator"></div>
    <div class="ChartTabs" style="padding-left: 45px;">
        <GenericDropdown :elementID="'PieChart_SeriesSelector'" :options="PieChart_SeriesOptions" :OnChange="OnPieChartSelectedSeriesChange" />
    </div>
    <div class="ChartContainer">
        <div class="ChartWrapper">
            <VuePlotly :data="PieChart_SelectedSeriesPurpleData" :layout="PieChart_SelectedSeries_Purple_Layout" :config="config" />
        </div>
        <div class="ChartWrapper">
            <VuePlotly :data="PieChart_SelectedSeriesOrangeData" :layout="PieChart_SelectedSeries_Orange_Layout" :config="config" />
        </div>
        <div class="ChartWrapper">
            <VuePlotly :data="PieChart_SelectedSeriesWhiteData" :layout="PieChart_SelectedSeries_White_Layout" :config="config" />
        </div>
    </div>
    <div class="Separator"></div>
    <div class="ChartContainer">
        <div class="ChartWrapper">
            <VuePlotly :data="CostIncludingExpenseChartData" :layout="CostIncludingPieChartLayout" :config="config" />
        </div>
        <div class="ChartWrapper">
            <VuePlotly :data="CostExcludingExpenseChartData" :layout="CostExcludingPieChartLayout" :config="config" />
        </div>
        <div class="ChartWrapper">
            <VuePlotly :data="OtherCostExpenseChartData" :layout="OtherCostPieChartLayout" :config="config" />
        </div>
    </div>

<!--
    <div class="Separator"></div>
    <div class="ChartContainer">
        <div class="ChartWrapper">
            <VuePlotly :data="HanbaisakiSalesChartData" :layout="salesChartLayout" :config="config" />
        </div>
        <div class="ChartWrapper">
            <VuePlotly :data="HanbaisakiProfitChartData" :layout="profitChartLayout" :config="config" />
        </div>
        <div class="ChartWrapper">
            <VuePlotly :data="HanbaisakiOrdersChartData" :layout="ordersChartLayout" :config="config" />
        </div>
    </div>
    <div class="Separator"></div>
    <div class="ChartContainer">
        <div class="ChartWrapper">
            <div class="ChartTabs">
                <GenericDropdown :elementID="'BrandDataSelector'" :options="ChartTabOptions" :OnChange="OnBrandChartTypeChange" />
            </div>
            <VuePlotly :data="BrandChartData" :layout="BrandChartLayout" :config="config" />
        </div>
    </div>
    <div class="Separator"></div>
    <div class="ChartContainer">
        <div class="ChartWrapper">
            <div class="ChartTabs">
                <GenericDropdown :elementID="'SeriesDataSelector'" :options="ChartTabOptions" :OnChange="OnSeriesChartTypeChange" />
            </div>
            <VuePlotly :data="SeriesChartData" :layout="SeriesChartLayout" :config="config" />
        </div>
    </div>
    <div class="Separator"></div>
    <div class="ChartContainer">
        <div class="ChartWrapper">
            <div class="ChartTabs">
                <GenericDropdown :elementID="'FactoryDataSelector'" :options="ChartTabOptions" :OnChange="OnFactoryChartTypeChange" />
            </div>
            <VuePlotly :data="FactoryChartData" :layout="FactoryChartLayout" :config="config" />
        </div>
    </div>
-->


    <!-- <div class="Separator"></div>
    <div class="ChartContainer">
        <div class="ChartWrapper">
            <div class="ChartTabs">
                <GenericDropdown :elementID="'DistributorSeriesDataSelector'" :options="ChartTabOptions" :OnChange="OnDistributorSeriesChartTypeChange" />
            </div>
            <VuePlotly :data="DistributorSeriesChartData" :layout="DistributorSeriesChartLayout" :config="config" />
        </div>
    </div>
    <div class="Separator"></div>
    <div class="ChartContainer">
        <div class="ChartWrapper">
            <div class="ChartTabs">
                <GenericDropdown :elementID="'DistributorBrandsDataSelector'" :options="ChartTabOptions" :OnChange="OnDistributorBrandsChartTypeChange" />
            </div>
            <VuePlotly :data="DistributorBrandsChartData" :layout="DistributorBrandsChartLayout" :config="config" />
        </div>
    </div> -->
</template>

<script>
import { VuePlotly } from '@/classes/VuePlotly';
import axios from 'axios'
import moment from "moment";
// import DatePicker from "./components/DatePicker.vue";
import Analytics_Distributor from '@/classes/Analytics_Distributor';
import GenericDropdown from '@/components/GenericDropdown.vue';
import { ShowLoading } from '@/utils/FullScreenLoading';
import VueSlider from 'vue-3-slider-component';

export default{
    components: {
        GenericDropdown,
        VuePlotly,
        // DatePicker,
        VueSlider,
    },
    mounted(){
        this.GetData();
    },
    computed:{
        
    },
    methods:{
        OnFilterYearChange()
        {
            this.GetData();
        },
        OnFilterMonthChange()
        {
            this.GetData();
        },
        OnBrandChartTypeChange(event)
        {
            this.SelectedBrandDataType = event.target.selectedIndex;

            this.UpdateBrandChartData();
        },
        OnSeriesChartTypeChange(event)
        {
            this.SelectedSeriesDataType = event.target.selectedIndex;

            this.UpdateSeriesChartData();
        },
        OnFactoryChartTypeChange(event)
        {
            this.SelectedFactoryDataType = event.target.selectedIndex;

            this.UpdateFactoryChartData();
        },
        OnDistributorSeriesChartTypeChange(event)
        {
            this.SelectedDistributorSeriesDataType = event.target.selectedIndex;

            this.UpdateDistributorChartData();
        },
        OnDistributorBrandsChartTypeChange(event)
        {
            this.SelectedDistributorBrandsDataType = event.target.selectedIndex;

            this.UpdateDistributorChartData();
        },
        OnPieChartSelectedSeriesChange(event)
        {
            this.PieChart_SelectedSeries = event.target.selectedIndex;

            this.UpdatePieChart_Series();
        },
        OnTotalCostPieChartChange(event)
        {
            this.PieChart_SelectedTotalCostComparison = event.target.selectedIndex;

            this.$nextTick(()=>{
                switch (this.PieChart_SelectedTotalCostComparison)
                {
                    case 0: 
                        this.CreateChartTile('PieChart_Total_Series_Main');
                        // this.CreateChartTile('PieChart_Total_Series_Sub');
                        this.CreateChartLegendTile('PieChart_Total_Series_Sub');
                        break;

                    case 1:
                        this.CreateChartTile('PieChart_Total_Brand_Main');
                        // this.CreateChartTile('PieChart_Total_Brand_Sub');
                        this.CreateChartLegendTile('PieChart_Total_Brand_Sub');
                        break;

                    case 2:
                        this.CreateChartTile('PieChart_Total_Factory_Main');
                        // this.CreateChartTile('PieChart_Total_Factory_Sub');
                        this.CreateChartLegendTile('PieChart_Total_Factory_Sub');
                        break;
                }
            });
        },
        async GetData()
        {
            ShowLoading(true, 'ローディング中');

            const startDate = moment();
            startDate.year(this.FilterYear[0]);
            startDate.month(this.FilterYear[0] === this.FilterYear[1] ? this.FilterMonth[0] : 1);
            startDate.date(0);
            startDate.hour(0);
            startDate.minute(0);
            startDate.second(0);

            const endDate = moment();
            endDate.year(this.FilterYear[1]);
            endDate.month(this.FilterYear[0] === this.FilterYear[1] ? this.FilterMonth[1] : 12);
            endDate.date(0);
            endDate.hour(0);
            endDate.minute(0);
            endDate.second(0);

            const param = {
                SessionToken: this.$GetToken(),
                // StartDate: this.SelectedFilterDate[0].format(`YYYY-MM-DD ${process.env.VUE_APP_TIMEZONE_ADD_HOURS}:mm:ss`),
                // EndDate: this.SelectedFilterDate[1].format(`YYYY-MM-DD ${process.env.VUE_APP_TIMEZONE_ADD_HOURS}:mm:ss`)
                StartDate: startDate.format(`YYYY-MM-DD ${process.env.VUE_APP_TIMEZONE_ADD_HOURS}:mm:ss`),
                EndDate: endDate.format(`YYYY-MM-DD ${process.env.VUE_APP_TIMEZONE_ADD_HOURS}:mm:ss`),
            };

            this.SourceData = await axios.post(`${process.env.VUE_APP_BACKEND_URL}data/all`, param)
            .then(response => {
                ShowLoading(false);
                return response.data;
            })
            .catch(error => {
                ShowLoading(false);
                if (error.response.status != 500)
                {
                    this.$HandleBadRequest(error.response.status, error.response.data);
                }
                console.log('Error when trying to receive source data', error);
                return null;
            });

            console.log('Source data', this.SourceData);

            if (this.SourceData === null ||
                this.SourceData === undefined)
            {
                return;
            }

            this.Distributors = [];
            for (let i = 0; i < this.SourceData.hanbaisakis.length; i++)
            {
                this.Distributors.push({ label: this.SourceData.hanbaisakis[i].name, value: this.SourceData.hanbaisakis[i].id});
            }

            for (let i = 0; i < this.SourceData.keikakumeisaiProducts.length; i++)
            {
                const product = this.SourceData.keikakumeisaiProducts[i];
                product.Data = [];
                for (let j = 0; j < this.SourceData.keikakumeisaiData.length; j++)
                {
                    const data = this.SourceData.keikakumeisaiData[j];

                    if (data.productID === product.id)
                    {
                        delete data.productID;
                        this.SourceData.keikakumeisaiProducts[i].Data.push(data);
                    }
                }
            }

            this.MinFilterYear = this.SourceData.minMaxYear.minYear;
            this.MaxFilterYear = this.SourceData.minMaxYear.maxYear;

            if (this.MinFilterYear === undefined)
            {
                this.MinFilterYear = new Date().getFullYear();
                this.MaxFilterYear = this.MinFilterYear;
            }

            console.log('Min filter year', this.MinFilterYear);
            console.log('Max filter year', this.MaxFilterYear);

            delete this.SourceData.keikakumeisaiData;

            this.SourceData.yearTTL.total_sales = parseInt(this.SourceData.yearTTL.total_sales);
            this.SourceData.yearTTL.total_profit = parseInt(this.SourceData.yearTTL.total_profit);

            this.CurrentYearSales = this.FormatTraceText(this.SourceData.yearTTL.total_sales);
            this.CurrentYearProfit = this.FormatTraceText(this.SourceData.yearTTL.total_profit);
            this.CurrentYear = this.SourceData.yearTTL.year;
            this.CurrentMonth = this.SourceData.yearTTL.month;

            let t = null;

            t = document.getElementById('TotalSalesBar');
            const salesWidth = this.SourceData.yearTTL.total_sales * 100 / Math.max(this.SourceData.yearTTL.total_sales, this.SourceData.yearTTL.total_profit);
            t.style.width = `${salesWidth}%`;
            t.title = '¥' + this.SourceData.yearTTL.total_sales.toLocaleString('ja-JP');

            t = document.getElementById('TotalProfitBar');
            const profitWidth = (this.SourceData.yearTTL.total_profit * 100) / Math.max(this.SourceData.yearTTL.total_sales, this.SourceData.yearTTL.total_profit);
            t.style.width = `${profitWidth}%`;
            t.title = '¥' + this.SourceData.yearTTL.total_profit.toLocaleString('ja-JP');

            t = document.getElementById('TotalSalesPercentage');
            t.textContent = `${salesWidth}%`;

            t = document.getElementById('TotalProfitPercentage');
            t.textContent = `${Math.round(profitWidth)}%`;

            this.GetKeikakumeisaiTotalSalesPerYear();
            this.GetHanbaisakiSales();
            this.GetKeikakumeisaiDetails();
            this.UpdateBrandChartData();
            this.UpdateSeriesChartData();
            this.UpdateFactoryChartData();
            this.UpdateDistributorChartData();
            this.UpdateCostPieCharts();
            this.UpdatePieChart_Series();
            this.UpdatePieChart_SeriesCost();
            this.UpdatePieChart_BrandCost();
            this.UpdatePieChart_FactoryCost();
        },
        async GetKeikakumeisaiDetails()
        {
            this.BrandData = [];
            this.SeriesData = [];
            this.FactoryData = [];
            this.TotalCosts = {
                GrossOperatingProfit: 0,
                NumberOfReturns: 0,
                Orders: 0,
                Profit: 0,
                Sales: 0,
                Zaiko: 0,
                CostIncludingExpenses: {
                    PurchaseAmountGroup: 0,
                    PurchaseAmount: 0,
                    SamplePurchaseAmount: 0,
                    Customs: 0,
                    ShippingExpenses: 0,
                    HeadOfficeExpenses: 0
                },
                CostExcludingExpenses: {
                    Prototype: 0,
                    Mold: 0,
                    CopyrightFees: 0,
                    SalesCommissionGroup: 0,
                    Sculptor: 0,
                    SalesCommission_PB: 0,
                    ECFees: 0,
                    ECPaymentFees: 0,
                    CardFees: 0,
                    ShippingFeesGroup: 0,
                    Shipping_Warehouse: 0,
                    Shipping_PB: 0,
                    ShippingHandlingGroup: 0,
                    Handling_Warehouse: 0,
                    Handling_PB: 0,
                    Devan: 0,
                    StorageFee: 0,
                },
                OtherCost: {
                    WAX: 0,
                    PackageDesign: 0,
                    // Commission_Alan: 0,
                    Commission_Production: 0,
                    //ShippingCase: 0,
                    SamplesCost: 0
                }
            };

            this.DistributorData = [];

            for (let i = 0; i < this.SourceData.keikakumeisaiProducts.length; i++)
            {
                let p = this.SourceData.keikakumeisaiProducts[i];

                let b = null;
                let s = null;
                let f = null;

                for (let j = 0; j < this.BrandData.length; j++)
                {
                    if (this.BrandData[j].brand === p.brand)
                    {
                        b = this.BrandData[j];
                        break;
                    }
                }

                for (let j = 0; j < this.SeriesData.length; j++)
                {
                    if (this.SeriesData[j].series === p.series)
                    {
                        s = this.SeriesData[j];
                        break;
                    }
                }

                for (let j = 0; j < this.FactoryData.length; j++)
                {
                    if (this.FactoryData[j].factory === p.factory)
                    {
                        f = this.FactoryData[j];
                        break;
                    }
                }

                if (b === null)
                {
                    b = {
                        brand: p.brand,
                        orders: 0,
                        copyrightFees: 0,
                        grossOperatingProfit: 0,
                        profit: 0,
                        sales: 0,
                        numberOfReturns: 0,
                        zaiko: 0,
                        // Cost
                        CostIncludingExpenses: {
                            PurchaseAmountGroup: 0,
                            PurchaseAmount: 0,
                            SamplePurchaseAmount: 0,
                            Customs: 0,
                            ShippingExpenses: 0,
                            HeadOfficeExpenses: 0
                        },
                        CostExcludingExpenses: {
                            Prototype: 0,
                            Mold: 0,
                            CopyrightFees: 0,
                            SalesCommissionGroup: 0,
                            Sculptor: 0,
                            SalesCommission_PB: 0,
                            ECFees: 0,
                            ECPaymentFees: 0,
                            CardFees: 0,
                            ShippingFeesGroup: 0,
                            Shipping_Warehouse: 0,
                            Shipping_PB: 0,
                            ShippingHandlingGroup: 0,
                            Handling_Warehouse: 0,
                            Handling_PB: 0,
                            Devan: 0,
                            StorageFee: 0,
                        },
                        OtherCost: {
                            WAX: 0,
                            PackageDesign: 0,
                            // Commission_Alan: 0,
                            Commission_Production: 0,
                            //ShippingCase: 0,
                            SamplesCost: 0
                        }
                    };

                    this.BrandData.push(b);
                }

                if (s === null)
                {
                    s = {
                        series: p.series,
                        orders: 0,
                        copyrightFees: 0,
                        grossOperatingProfit: 0,
                        profit: 0,
                        sales: 0,
                        numberOfReturns: 0,
                        zaiko: 0,
                        // Cost
                        CostIncludingExpenses: {
                            PurchaseAmountGroup: 0,
                            PurchaseAmount: 0,
                            SamplePurchaseAmount: 0,
                            Customs: 0,
                            ShippingExpenses: 0,
                            HeadOfficeExpenses: 0
                        },
                        CostExcludingExpenses: {
                            Prototype: 0,
                            Mold: 0,
                            CopyrightFees: 0,
                            SalesCommissionGroup: 0,
                            Sculptor: 0,
                            SalesCommission_PB: 0,
                            ECFees: 0,
                            ECPaymentFees: 0,
                            CardFees: 0,
                            ShippingFeesGroup: 0,
                            Shipping_Warehouse: 0,
                            Shipping_PB: 0,
                            ShippingHandlingGroup: 0,
                            Handling_Warehouse: 0,
                            Handling_PB: 0,
                            Devan: 0,
                            StorageFee: 0,
                        },
                        OtherCost: {
                            WAX: 0,
                            PackageDesign: 0,
                            // Commission_Alan: 0,
                            Commission_Production: 0,
                            //ShippingCase: 0,
                            SamplesCost: 0
                        }
                    };

                    this.SeriesData.push(s);
                    this.PieChart_SeriesOptions.push({label:s.series, value: this.PieChart_SeriesOptions.length});
                }

                if (f === null)
                {
                    f = {
                        factory: p.factory,
                        orders: 0,
                        copyrightFees: 0,
                        grossOperatingProfit: 0,
                        profit: 0,
                        sales: 0,
                        numberOfReturns: 0,
                        zaiko: 0,
                        // Cost
                        CostIncludingExpenses: {
                            PurchaseAmountGroup: 0,
                            PurchaseAmount: 0,
                            SamplePurchaseAmount: 0,
                            Customs: 0,
                            ShippingExpenses: 0,
                            HeadOfficeExpenses: 0
                        },
                        CostExcludingExpenses: {
                            Prototype: 0,
                            Mold: 0,
                            CopyrightFees: 0,
                            SalesCommissionGroup: 0,
                            Sculptor: 0,
                            SalesCommission_PB: 0,
                            ECFees: 0,
                            ECPaymentFees: 0,
                            CardFees: 0,
                            ShippingFeesGroup: 0,
                            Shipping_Warehouse: 0,
                            Shipping_PB: 0,
                            ShippingHandlingGroup: 0,
                            Handling_Warehouse: 0,
                            Handling_PB: 0,
                            Devan: 0,
                            StorageFee: 0,
                        },
                        OtherCost: {
                            WAX: 0,
                            PackageDesign: 0,
                            // Commission_Alan: 0,
                            Commission_Production: 0,
                            //ShippingCase: 0,
                            SamplesCost: 0
                        }
                    };

                    this.FactoryData.push(f);
                }

                for (let j = 0; j < p.Data.length; j++)
                {
                    const d = p.Data[j];

                    // Brands
                    {
                        b.orders += d.amount;
                        b.grossOperatingProfit += d.grossOperatingProfit;
                        b.profit += d.profit;
                        b.sales += d.sales;
                        b.numberOfReturns += d.numberOfReturns;
                        b.zaiko += d.zaiko;
                        // Cost
                        b.CostIncludingExpenses.PurchaseAmountGroup += d.purchaseAmount;
                        b.CostIncludingExpenses.PurchaseAmountGroup += d.samplePurchaseAmount;
                        b.CostIncludingExpenses.PurchaseAmount += d.purchaseAmount;
                        b.CostIncludingExpenses.SamplePurchaseAmount += d.samplePurchaseAmount;
                        b.CostIncludingExpenses.Customs += d.customs;
                        b.CostIncludingExpenses.ShippingExpenses += d.shippingExpenses;
                        b.CostIncludingExpenses.HeadOfficeExpenses += d.headOfficeExpenses;
                        
                        b.CostExcludingExpenses.Prototype += d.prototypeCost;
                        b.CostExcludingExpenses.Mold += d.moldCost;
                        b.CostExcludingExpenses.CopyrightFees += d.copyrightFees;
                        b.CostExcludingExpenses.SalesCommissionGroup += d.commission_sculptor;
                        b.CostExcludingExpenses.SalesCommissionGroup += d.commission_pb;
                        b.CostExcludingExpenses.Sculptor += d.commission_sculptor;
                        b.CostExcludingExpenses.SalesCommission_PB += d.commission_pb;
                        b.CostExcludingExpenses.ECFees += d.fee_it_pb_ec;
                        b.CostExcludingExpenses.ECFees += d.fee_cardPayment;
                        b.CostExcludingExpenses.ECPaymentFees += d.fee_it_pb_ec;
                        b.CostExcludingExpenses.CardFees += d.fee_cardPayment;
                        b.CostExcludingExpenses.ShippingFeesGroup += d.shipping_warehouse;
                        b.CostExcludingExpenses.ShippingFeesGroup += d.shipping_pb;
                        b.CostExcludingExpenses.Shipping_Warehouse += d.shipping_warehouse;
                        b.CostExcludingExpenses.Shipping_PB += d.shipping_pb;
                        b.CostExcludingExpenses.ShippingHandlingGroup += d.handling_warehouse;
                        b.CostExcludingExpenses.ShippingHandlingGroup += d.handling_pb;
                        b.CostExcludingExpenses.Handling_Warehouse += d.handling_warehouse;
                        b.CostExcludingExpenses.Handling_PB += d.handling_pb;
                        b.CostExcludingExpenses.Devan += d.devanning;
                        b.CostExcludingExpenses.StorageFee += d.fee_storage;
                        
                        b.OtherCost.WAX += d.WAX
                        b.OtherCost.PackageDesign += d.packageDesign;
                        // b.OtherCost.Commission_Alan += d.commission_alan;
                        b.OtherCost.Commission_Production += d.commission_production;
                        //b.OtherCost.ShippingCase += d.shippingCase;
                        b.OtherCost.SamplesCost += d.samplesCost < 0 ? -d.samplesCost : d.samplesCost;
                    }

                    // Series
                    {
                        s.orders += d.amount;
                        s.grossOperatingProfit += d.grossOperatingProfit;
                        s.profit += d.profit;
                        s.sales += d.sales;
                        s.numberOfReturns += d.numberOfReturns;
                        s.zaiko += d.zaiko;
                        // Cost
                        s.CostIncludingExpenses.PurchaseAmountGroup += d.purchaseAmount;
                        s.CostIncludingExpenses.PurchaseAmountGroup += d.samplePurchaseAmount;
                        s.CostIncludingExpenses.PurchaseAmount += d.purchaseAmount;
                        s.CostIncludingExpenses.SamplePurchaseAmount += d.samplePurchaseAmount;
                        s.CostIncludingExpenses.Customs += d.customs;
                        s.CostIncludingExpenses.ShippingExpenses += d.shippingExpenses;
                        s.CostIncludingExpenses.HeadOfficeExpenses += d.headOfficeExpenses;
                        
                        s.CostExcludingExpenses.Prototype += d.prototypeCost;
                        s.CostExcludingExpenses.Mold += d.moldCost;
                        s.CostExcludingExpenses.CopyrightFees += d.copyrightFees;
                        s.CostExcludingExpenses.SalesCommissionGroup += d.commission_sculptor;
                        s.CostExcludingExpenses.SalesCommissionGroup += d.commission_pb;
                        s.CostExcludingExpenses.Sculptor += d.commission_sculptor;
                        s.CostExcludingExpenses.SalesCommission_PB += d.commission_pb;
                        s.CostExcludingExpenses.ECFees += d.fee_it_pb_ec;
                        s.CostExcludingExpenses.ECFees += d.fee_cardPayment;
                        s.CostExcludingExpenses.ECPaymentFees += d.fee_it_pb_ec;
                        s.CostExcludingExpenses.CardFees += d.fee_cardPayment;
                        s.CostExcludingExpenses.ShippingFeesGroup += d.shipping_warehouse;
                        s.CostExcludingExpenses.ShippingFeesGroup += d.shipping_pb;
                        s.CostExcludingExpenses.Shipping_Warehouse += d.shipping_warehouse;
                        s.CostExcludingExpenses.Shipping_PB += d.shipping_pb;
                        s.CostExcludingExpenses.ShippingHandlingGroup += d.handling_warehouse;
                        s.CostExcludingExpenses.ShippingHandlingGroup += d.handling_pb;
                        s.CostExcludingExpenses.Handling_Warehouse += d.handling_warehouse;
                        s.CostExcludingExpenses.Handling_PB += d.handling_pb;
                        s.CostExcludingExpenses.Devan += d.devanning;
                        s.CostExcludingExpenses.StorageFee += d.fee_storage;
                        
                        s.OtherCost.WAX += d.WAX
                        s.OtherCost.PackageDesign += d.packageDesign;
                        // s.OtherCost.Commission_Alan += d.commission_alan;
                        s.OtherCost.Commission_Production += d.commission_production;
                        //s.OtherCost.ShippingCase += d.shippingCase;
                        s.OtherCost.SamplesCost += d.samplesCost < 0 ? -d.samplesCost : d.samplesCost;
                    }

                    // Factories
                    {
                        f.orders += d.amount;
                        f.grossOperatingProfit += d.grossOperatingProfit;
                        f.profit += d.profit;
                        f.sales += d.sales;
                        f.numberOfReturns += d.numberOfReturns;
                        f.zaiko += d.zaiko;
                        // Cost
                        f.CostIncludingExpenses.PurchaseAmountGroup += d.purchaseAmount;
                        f.CostIncludingExpenses.PurchaseAmountGroup += d.samplePurchaseAmount;
                        f.CostIncludingExpenses.PurchaseAmount += d.purchaseAmount;
                        f.CostIncludingExpenses.SamplePurchaseAmount += d.samplePurchaseAmount;
                        f.CostIncludingExpenses.Customs += d.customs;
                        f.CostIncludingExpenses.ShippingExpenses += d.shippingExpenses;
                        f.CostIncludingExpenses.HeadOfficeExpenses += d.headOfficeExpenses;
                        
                        f.CostExcludingExpenses.Prototype += d.prototypeCost;
                        f.CostExcludingExpenses.Mold += d.moldCost;
                        f.CostExcludingExpenses.CopyrightFees += d.copyrightFees;
                        f.CostExcludingExpenses.SalesCommissionGroup += d.commission_sculptor;
                        f.CostExcludingExpenses.SalesCommissionGroup += d.commission_pb;
                        f.CostExcludingExpenses.Sculptor += d.commission_sculptor;
                        f.CostExcludingExpenses.SalesCommission_PB += d.commission_pb;
                        f.CostExcludingExpenses.ECFees += d.fee_it_pb_ec;
                        f.CostExcludingExpenses.ECFees += d.fee_cardPayment;
                        f.CostExcludingExpenses.ECPaymentFees += d.fee_it_pb_ec;
                        f.CostExcludingExpenses.CardFees += d.fee_cardPayment;
                        f.CostExcludingExpenses.ShippingFeesGroup += d.shipping_warehouse;
                        f.CostExcludingExpenses.ShippingFeesGroup += d.shipping_pb;
                        f.CostExcludingExpenses.Shipping_Warehouse += d.shipping_warehouse;
                        f.CostExcludingExpenses.Shipping_PB += d.shipping_pb;
                        f.CostExcludingExpenses.ShippingHandlingGroup += d.handling_warehouse;
                        f.CostExcludingExpenses.ShippingHandlingGroup += d.handling_pb;
                        f.CostExcludingExpenses.Handling_Warehouse += d.handling_warehouse;
                        f.CostExcludingExpenses.Handling_PB += d.handling_pb;
                        f.CostExcludingExpenses.Devan += d.devanning;
                        f.CostExcludingExpenses.StorageFee += d.fee_storage;
                        
                        f.OtherCost.WAX += d.WAX
                        f.OtherCost.PackageDesign += d.packageDesign;
                        // f.OtherCost.Commission_Alan += d.commission_alan;
                        f.OtherCost.Commission_Production += d.commission_production;
                        //f.OtherCost.ShippingCase += d.shippingCase;
                        f.OtherCost.SamplesCost += d.samplesCost < 0 ? -d.samplesCost : d.samplesCost;
                    }

                    // Totals
                    {
                        this.TotalCosts.Orders += d.amount;
                        this.TotalCosts.GrossOperatingProfit += d.grossOperatingProfit;
                        this.TotalCosts.Profit += d.profit;
                        this.TotalCosts.Sales += d.sales;
                        this.TotalCosts.NumberOfReturns += d.numberOfReturns;
                        this.TotalCosts.Zaiko += d.zaiko;

                        this.TotalCosts.CostIncludingExpenses.PurchaseAmountGroup += d.purchaseAmount;
                        this.TotalCosts.CostIncludingExpenses.PurchaseAmountGroup += d.samplePurchaseAmount;
                        this.TotalCosts.CostIncludingExpenses.PurchaseAmount += d.purchaseAmount;
                        this.TotalCosts.CostIncludingExpenses.SamplePurchaseAmount += d.samplePurchaseAmount;
                        this.TotalCosts.CostIncludingExpenses.Customs += d.customs;
                        this.TotalCosts.CostIncludingExpenses.ShippingExpenses += d.shippingExpenses;
                        this.TotalCosts.CostIncludingExpenses.HeadOfficeExpenses += d.headOfficeExpenses;
                        
                        this.TotalCosts.CostExcludingExpenses.Prototype += d.prototypeCost;
                        this.TotalCosts.CostExcludingExpenses.Mold += d.moldCost;
                        this.TotalCosts.CostExcludingExpenses.CopyrightFees += d.copyrightFees;
                        this.TotalCosts.CostExcludingExpenses.SalesCommissionGroup += d.commission_sculptor;
                        this.TotalCosts.CostExcludingExpenses.SalesCommissionGroup += d.commission_pb;
                        this.TotalCosts.CostExcludingExpenses.Sculptor += d.commission_sculptor;
                        this.TotalCosts.CostExcludingExpenses.SalesCommission_PB += d.commission_pb;
                        this.TotalCosts.CostExcludingExpenses.ECFees += d.fee_it_pb_ec;
                        this.TotalCosts.CostExcludingExpenses.ECFees += d.fee_cardPayment;
                        this.TotalCosts.CostExcludingExpenses.ECPaymentFees += d.fee_it_pb_ec;
                        this.TotalCosts.CostExcludingExpenses.CardFees += d.fee_cardPayment;
                        this.TotalCosts.CostExcludingExpenses.ShippingFeesGroup += d.shipping_warehouse;
                        this.TotalCosts.CostExcludingExpenses.ShippingFeesGroup += d.shipping_pb;
                        this.TotalCosts.CostExcludingExpenses.Shipping_Warehouse += d.shipping_warehouse;
                        this.TotalCosts.CostExcludingExpenses.Shipping_PB += d.shipping_pb;
                        this.TotalCosts.CostExcludingExpenses.ShippingHandlingGroup += d.handling_warehouse;
                        this.TotalCosts.CostExcludingExpenses.ShippingHandlingGroup += d.handling_pb;
                        this.TotalCosts.CostExcludingExpenses.Handling_Warehouse += d.handling_warehouse;
                        this.TotalCosts.CostExcludingExpenses.Handling_PB += d.handling_pb;
                        this.TotalCosts.CostExcludingExpenses.Devan += d.devanning;
                        this.TotalCosts.CostExcludingExpenses.StorageFee += d.fee_storage;
                        
                        this.TotalCosts.OtherCost.WAX += d.WAX
                        this.TotalCosts.OtherCost.PackageDesign += d.packageDesign;
                        // this.TotalCosts.OtherCost.Commission_Alan += d.commission_alan;
                        this.TotalCosts.OtherCost.Commission_Production += d.commission_production;
                        //this.TotalCosts.OtherCost.ShippingCase += d.shippingCase;
                        this.TotalCosts.OtherCost.SamplesCost += d.samplesCost < 0 ? -d.samplesCost : d.samplesCost;
                        this.TotalCosts.OtherCost.Profit += d.profit;
                    }

                    let distributor = null;

                    for (let k = 0; k < this.DistributorData.length; k++)
                    {
                        if (this.DistributorData[k].name === d.hanbaisaki)
                        {
                            distributor = this.DistributorData[k];
                            break;
                        }
                    }

                    if (distributor === null)
                    {
                        distributor = {
                            name: d.hanbaisaki,
                            series: [],
                            brands: [],
                        };

                        this.DistributorData.push(distributor);
                    }

                    let seriesData = null;
                    for (let l = 0; l < distributor.series.length; l++)
                    {
                        if (distributor.series[l].name === p.series)
                        {
                            seriesData = distributor.series[l];
                            break;
                        }
                    }

                    if (seriesData === null)
                    {
                        seriesData = {
                            name: p.series,
                            sales: 0,
                            profit: 0,
                            orders: 0,
                            numberOfReturns: 0,
                        };

                        distributor.series.push(seriesData);
                    }

                    seriesData.sales += d.sales;
                    seriesData.profit += d.profit;
                    seriesData.orders += d.amount;
                    seriesData.numberOfReturns += d.numberOfReturns;

                    let brandData = null;
                    for (let l = 0; l < distributor.brands.length; l++)
                    {
                        if (distributor.brands[l].name === p.brand)
                        {
                            brandData = distributor.brands[l];
                            break;
                        }
                    }

                    if (brandData === null)
                    {
                        brandData = {
                            name: p.brand,
                            sales: 0,
                            profit: 0,
                            orders: 0,
                            numberOfReturns: 0,
                        };

                        distributor.brands.push(brandData);
                    }

                    brandData.sales += d.sales;
                    brandData.profit += d.profit;
                    brandData.orders += d.orders;
                    brandData.numberOfReturns += d.numberOfReturns;
                }
            }

            console.log('[Keikakumeisai] Brands', this.BrandData);
            console.log('[Keikakumeisai] Series', this.SeriesData);
            console.log('[Keikakumeisai] Factories', this.FactoryData);
            console.log('[Keikakumeisai] Distributors', this.DistributorData);
            console.log('[Keikakumeisai] Total cost', this.TotalCosts);
        },
        UpdateBrandChartData()
        {
            let newSalesChartData = {
                x:[],
                y:[],
                type: 'bar',
                name: '売上'
            };

            let newProfitChartData = {
                x:[],
                y:[],
                type: 'bar',
                name: '利益'
            };

            let newOrdersChartData = {
                x:[],
                y:[],
                type: 'bar',
                name: '受注数'
            };

            let newCopyrightFeesChartData = {
                x:[],
                y:[],
                type: 'bar',
                name: '著作権料'
            };

            let newReturnsChartData = {
                x:[],
                y:[],
                type: 'bar',
                name: '交換対応数'
            };

            let newInventoryChartData = {
                x:[],
                y:[],
                type: 'bar',
                name: '在庫'
            };

            let xAxis = [];

            for (let i = 0; i < this.BrandData.length; i++)
            {
                xAxis.push(this.BrandData[i].brand);

                newSalesChartData.y.push(this.BrandData[i].sales);
                newProfitChartData.y.push(this.BrandData[i].profit);
                newOrdersChartData.y.push(this.BrandData[i].orders);
                newCopyrightFeesChartData.y.push(this.BrandData[i].copyrightFees);
                newReturnsChartData.y.push(this.BrandData[i].numberOfReturns);
                newInventoryChartData.y.push(this.BrandData[i].zaiko);
            }

            newSalesChartData.x = xAxis;
            newProfitChartData.x = xAxis;
            newOrdersChartData.x = xAxis;
            newCopyrightFeesChartData.x = xAxis;
            newReturnsChartData.x = xAxis;
            newInventoryChartData.x = xAxis;

            let steps = 5;
            let highestValue = this.SelectedBrandDataType === 0 ? [...newSalesChartData.y].sort(this.CompareNumbersDesc)[0] : [...newOrdersChartData.y].sort(this.CompareNumbersDesc)[0];
            let stepValue = highestValue/steps;
            let tickvalues = [];
            for (let i = 0; i <= steps; i++)
            {
                tickvalues.push(stepValue*i);
            }

            let chartTitle = 'ブランド';
            let newChartLayout = {
                title: chartTitle,
                legend:{
                    orientation: 'h',
                    y: 1.2
                },
                paper_bgcolor: 'rgba(0,0,0,0)',
                yaxis:{
                    tickvals: tickvalues,
                    ticktext: tickvalues.map(value => this.FormatTraceText(value)),
                }
            };

            if (this.SelectedBrandDataType === 0)
            {
                this.BrandChartData = [newSalesChartData, newProfitChartData, newCopyrightFeesChartData, newInventoryChartData];
            }
            else
            {
                this.BrandChartData = [newOrdersChartData, newReturnsChartData];
            }
            
            this.BrandChartLayout = newChartLayout;
        },
        UpdateSeriesChartData()
        {
            let newSalesChartData = {
                x:[],
                y:[],
                type: 'bar',
                name: '売上'
            };

            let newProfitChartData = {
                x:[],
                y:[],
                type: 'bar',
                name: '利益'
            };

            let newOrdersChartData = {
                x:[],
                y:[],
                type: 'bar',
                name: '受注数'
            };

            let newCopyrightFeesChartData = {
                x:[],
                y:[],
                type: 'bar',
                name: '著作権料'
            };

            let newReturnsChartData = {
                x:[],
                y:[],
                type: 'bar',
                name: '交換対応数'
            };

            let newInventoryChartData = {
                x:[],
                y:[],
                type: 'bar',
                name: '在庫'
            };

            let xAxis = [];

            for (let i = 0; i < this.SeriesData.length; i++)
            {
                xAxis.push(this.SeriesData[i].series);

                newSalesChartData.y.push(this.SeriesData[i].sales);
                newProfitChartData.y.push(this.SeriesData[i].profit);
                newOrdersChartData.y.push(this.SeriesData[i].orders);
                newCopyrightFeesChartData.y.push(this.SeriesData[i].copyrightFees);
                newReturnsChartData.y.push(this.SeriesData[i].numberOfReturns);
                newInventoryChartData.y.push(this.SeriesData[i].zaiko);
            }

            newSalesChartData.x = xAxis;
            newProfitChartData.x = xAxis;
            newOrdersChartData.x = xAxis;
            newCopyrightFeesChartData.x = xAxis;
            newReturnsChartData.x = xAxis;
            newInventoryChartData.x = xAxis;

            let steps = 5;
            let highestValue = this.SelectedSeriesDataType === 0 ? [...newSalesChartData.y].sort(this.CompareNumbersDesc)[0] : [...newOrdersChartData.y].sort(this.CompareNumbersDesc)[0];
            let stepValue = highestValue/steps;
            let tickvalues = [];
            for (let i = 0; i <= steps; i++)
            {
                tickvalues.push(stepValue*i);
            }

            let chartTitle = 'シリーズ';
            let newChartLayout = {
                title: chartTitle,
                legend:{
                    orientation: 'h',
                    y: 1.2
                },
                paper_bgcolor: 'rgba(0,0,0,0)',
                yaxis:{
                    tickvals: tickvalues,
                    ticktext: tickvalues.map(value => this.FormatTraceText(value)),
                }
            };

            if (this.SelectedSeriesDataType === 0)
            {
                this.SeriesChartData = [newSalesChartData, newProfitChartData, newCopyrightFeesChartData, newInventoryChartData];
            }
            else
            {
                this.SeriesChartData = [newOrdersChartData, newReturnsChartData];
            }

            this.SeriesChartLayout = newChartLayout;
        },
        UpdateFactoryChartData()
        {
            let newSalesChartData = {
                x:[],
                y:[],
                type: 'bar',
                name: '売上'
            };

            let newProfitChartData = {
                x:[],
                y:[],
                type: 'bar',
                name: '利益'
            };

            let newOrdersChartData = {
                x:[],
                y:[],
                type: 'bar',
                name: '受注数'
            };

            let newCopyrightFeesChartData = {
                x:[],
                y:[],
                type: 'bar',
                name: '著作権料'
            };

            let newReturnsChartData = {
                x:[],
                y:[],
                type: 'bar',
                name: '交換対応数'
            };

            let newInventoryChartData = {
                x:[],
                y:[],
                type: 'bar',
                name: '在庫'
            };

            let xAxis = [];

            for (let i = 0; i < this.FactoryData.length; i++)
            {
                xAxis.push(this.FactoryData[i].factory);

                newSalesChartData.y.push(this.FactoryData[i].sales);
                newProfitChartData.y.push(this.FactoryData[i].profit);
                newOrdersChartData.y.push(this.FactoryData[i].orders);
                newCopyrightFeesChartData.y.push(this.FactoryData[i].copyrightFees);
                newReturnsChartData.y.push(this.FactoryData[i].numberOfReturns);
                newInventoryChartData.y.push(this.FactoryData[i].zaiko);
            }

            newSalesChartData.x = xAxis;
            newProfitChartData.x = xAxis;
            newOrdersChartData.x = xAxis;
            newCopyrightFeesChartData.x = xAxis;
            newReturnsChartData.x = xAxis;
            newInventoryChartData.x = xAxis;

            let steps = 5;
            let highestValue = this.SelectedFactoryDataType === 0 ? [...newSalesChartData.y].sort(this.CompareNumbersDesc)[0] : [...newOrdersChartData.y].sort(this.CompareNumbersDesc)[0];
            let stepValue = highestValue/steps;
            let tickvalues = [];
            for (let i = 0; i <= steps; i++)
            {
                tickvalues.push(stepValue*i);
            }

            let chartTitle = '工場';
            let newChartLayout = {
                title: chartTitle,
                legend:{
                    orientation: 'h',
                    y: 1.2
                },
                paper_bgcolor: 'rgba(0,0,0,0)',
                yaxis:{
                    tickvals: tickvalues,
                    ticktext: tickvalues.map(value => this.FormatTraceText(value)),
                }
            };

            if (this.SelectedFactoryDataType === 0)
            {
                this.FactoryChartData = [newSalesChartData, newProfitChartData, newCopyrightFeesChartData, newInventoryChartData];
            }
            else
            {
                this.FactoryChartData = [newOrdersChartData, newReturnsChartData];
            }
            
            this.FactoryChartLayout = newChartLayout;
        },
        UpdateDistributorChartData()
        {
            let newSeriesSalesChartData = {
                x:[],
                y:[],
                type: 'bar',
                name: '売上'
            };

            let newSeriesProfitChartData = {
                x:[],
                y:[],
                type: 'bar',
                name: '利益'
            };

            let newSeriesOrdersChartData = {
                x:[],
                y:[],
                type: 'bar',
                name: '受注数'
            };

            let newSeriesReturnsChartData = {
                x:[],
                y:[],
                type: 'bar',
                name: '交換対応数'
            };

            let newBrandsSalesChartData = {
                x:[],
                y:[],
                type: 'bar',
                name: '売上'
            };

            let newBrandsProfitChartData = {
                x:[],
                y:[],
                type: 'bar',
                name: '利益'
            };

            let newBrandsOrdersChartData = {
                x:[],
                y:[],
                type: 'bar',
                name: '受注数'
            };

            let newBrandsReturnsChartData = {
                x:[],
                y:[],
                type: 'bar',
                name: '交換対応数'
            };

            let xAxis = [];

            console.log('this.DistributorData', this.DistributorData);
            for (let i = 0; i < this.DistributorData.length; i++)
            {
                let dis = this.DistributorData[i];

                xAxis.push(dis.name);

                for (let j = 0; j < dis.series.length; j++)
                {
                    let ser = dis.series[j];
                    newSeriesSalesChartData.y.push(ser.sales);
                    newSeriesProfitChartData.y.push(ser.profit);
                    newSeriesOrdersChartData.y.push(ser.orders);
                    newSeriesReturnsChartData.y.push(ser.numberOfReturns);
                }

                for (let j = 0; j < dis.brands.length; j++)
                {
                    let bra = dis.brands[j];
                    newBrandsSalesChartData.y.push(bra.sales);
                    newBrandsProfitChartData.y.push(bra.profit);
                    newBrandsOrdersChartData.y.push(bra.orders);
                    newBrandsReturnsChartData.y.push(bra.numberOfReturns);
                }
            }

            newSeriesSalesChartData.x = xAxis;
            newSeriesProfitChartData.x = xAxis;
            newSeriesOrdersChartData.x = xAxis;
            newSeriesReturnsChartData.x = xAxis;

            newBrandsSalesChartData.x = xAxis;
            newBrandsProfitChartData.x = xAxis;
            newBrandsOrdersChartData.x = xAxis;
            newBrandsReturnsChartData.x = xAxis;

            console.log('dist. series sales', newSeriesSalesChartData);

            let steps = 5;
            let highestValue = [...newSeriesSalesChartData.y].sort(this.CompareNumbersDesc)[0];
            let stepValue = highestValue/steps;
            let tickvalues = [];
            for (let i = 0; i <= steps; i++)
            {
                tickvalues.push(stepValue*i);
            }

            let chartTitle = '販売先・シリーズ';
            let newSeriesChartLayout = {
                title: chartTitle,
                legend:{
                    orientation: 'h',
                    y: 1.2
                },
                paper_bgcolor: 'rgba(0,0,0,0)',
                yaxis:{
                    tickvals: tickvalues,
                    ticktext: tickvalues.map(value => this.FormatTraceText(value)),
                }
            };

            steps = 5;
            highestValue = [...newBrandsSalesChartData.y].sort(this.CompareNumbersDesc)[0];
            stepValue = highestValue/steps;
            tickvalues = [];
            for (let i = 0; i <= steps; i++)
            {
                tickvalues.push(stepValue*i);
            }

            chartTitle = '販売先・ブランド';
            let newBrandsChartLayout = {
                title: chartTitle,
                legend:{
                    orientation: 'h',
                    y: 1.2
                },
                paper_bgcolor: 'rgba(0,0,0,0)',
                yaxis:{
                    tickvals: tickvalues,
                    ticktext: tickvalues.map(value => this.FormatTraceText(value)),
                }
            };

            this.DistributorSeriesChartData = [newSeriesSalesChartData, newSeriesProfitChartData, newSeriesOrdersChartData, newSeriesReturnsChartData];
            this.DistributorSeriesChartLayout = newSeriesChartLayout;
            
            this.DistributorBrandsChartData = [newBrandsSalesChartData, newBrandsProfitChartData, newBrandsOrdersChartData, newBrandsReturnsChartData];
            this.DistributorBrandsChartLayout = newBrandsChartLayout;

            // console.log('Distributor series', this.DistributorSeriesChartData);
            // console.log('Distributor brands', this.DistributorBrandsChartData);
        },
        UpdatePieChart_Series()
        {
            let s = this.SeriesData[this.PieChart_SelectedSeries];

            let pValues = [
                s.CostIncludingExpenses.PurchaseAmount,
                s.CostIncludingExpenses.SamplePurchaseAmount,
                s.CostIncludingExpenses.Customs,
                s.CostIncludingExpenses.ShippingExpenses,
                s.CostIncludingExpenses.HeadOfficeExpenses,
            ];

            let oValues = [
                s.CostExcludingExpenses.Prototype,
                s.CostExcludingExpenses.Mold,
                s.CostExcludingExpenses.CopyrightFees,
                s.CostExcludingExpenses.Sculptor,
                s.CostExcludingExpenses.SalesCommission_PB,
                s.CostExcludingExpenses.ECPaymentFees,
                s.CostExcludingExpenses.CardFees,
                s.CostExcludingExpenses.Shipping_Warehouse,
                s.CostExcludingExpenses.Shipping_PB,
                s.CostExcludingExpenses.Handling_Warehouse,
                s.CostExcludingExpenses.Handling_PB,
                s.CostExcludingExpenses.Devan,
                s.CostExcludingExpenses.StorageFee
            ];

            let wValues = [
                s.OtherCost.WAX,
                s.OtherCost.PackageDesign,
                // s.OtherCost.Commission_Alan,
                s.OtherCost.Commission_Production,
                //s.OtherCost.ShippingCase,
                s.OtherCost.SamplesCost
            ];

            let newPurpleData = [{
                values: pValues,
                labels: [
                    '仕入額',
                    '見本仕入額',
                    '関税',
                    '船積経費',
                    '本社費',
                ],
                marker:{
                  colors: [
                    '#4444ff',
                    '#9999ff',
                    '#aaaaaa',
                    '#9F000F',
                    '#3CB371'
                  ]  
                },
                width: 600,
                height: 800,
                domain: {column: 1},
                text: pValues.map(value => `￥${this.FormatTraceText(value)}`),
                textinfo: 'percent',
                hoverinfo: 'label+text',
                type: 'pie',
                hole: .4,
            }];

            let newOrangeData = [{
                values: oValues,
                labels: [
                    '原型',
                    '金型',
                    '著作権料',
                    '原型師',
                    '売上_PB',
                    'IT/PB EC決済手数料',
                    'ｶｰﾄﾞ決済手数料',
                    '出荷手数料_倉庫',
                    '出荷手数料_PB',
                    '配送料_倉庫',
                    '配送料_PB',
                    'ﾃﾞﾊﾞﾝ',
                    '保管料'
                ],
                marker:{
                    colors:[
                        '#ff44ff',
                        '#ff4444',
                        '#44ff44',
                        '#8B4513',
                        '#AD6735',
                        '#FFC0CB',
                        '#FFE2ED',
                        '#00FFFF',
                        '#55FFFF',
                        '#FF5F1F',
                        '#FF7F3F',
                        '#CA762B',
                        '#FF8674'
                    ]
                },
                domain: {column: 1},
                text: oValues.map(value => `￥${this.FormatTraceText(value)}`),
                textinfo: 'percent',
                hoverinfo: 'label+text',
                type: 'pie',
                hole: .4,
            }];

            let newWhiteData = [{
                values: wValues,
                labels: [
                    'WAX',
                    'PKGﾃﾞｻﾞｲﾝ',
                    // '阿蘭さん固定ｺﾐｯｼｮﾝ',
                    '生産ｺﾐｯｼｮﾝ',
                    //'出荷ｹｰｽ',
                    '見本品費'
                ],
                marker:{
                    colors:[
                        '#FFB2D0',
                        '#967BB6',
                        '#C9C0BB',
                        '#8FB31D'
                    ]
                },
                width: 600,
                domain: {column: 1},
                text: wValues.map(value => `￥${this.FormatTraceText(value)}`),
                textinfo: 'percent',
                hoverinfo: 'label+text',
                type: 'pie',
                hole: .4,
            }];

            this.PieChart_SelectedSeriesPurpleData = newPurpleData;
            this.PieChart_SelectedSeriesOrangeData = newOrangeData;
            this.PieChart_SelectedSeriesWhiteData = newWhiteData;

            this.PieChart_SelectedSeries_Purple_Layout = {
                title: `${s.series}・原価算入経費`,
                showlegend: true,
            };

            this.PieChart_SelectedSeries_Orange_Layout = {
                title: `${s.series}・原価算入外経費`,
                showlegend: true,
            };

            this.PieChart_SelectedSeries_White_Layout = {
                title: `${s.series}・共通経費`,
                showlegend: true,
            };
        },
        UpdatePieChart_SeriesCost()
        {
            let chartValues = [
                {
                    order: 0,
                    value: this.TotalCosts.CostIncludingExpenses.Customs ?? 0,
                    color: '#aaaaaa',
                    label: '関税',
                },
                {
                    order: 1,
                    value: this.TotalCosts.CostIncludingExpenses.HeadOfficeExpenses ?? 0,
                    color: '#3CB371',
                    label: '本社費',
                },
                {
                    order: 2,
                    value: this.TotalCosts.CostIncludingExpenses.PurchaseAmountGroup ?? 0,
                    color: '#4444ff',
                    label: '仕入額',
                },
                {
                    order: 3,
                    value: this.TotalCosts.CostIncludingExpenses.ShippingExpenses ?? 0,
                    color: '#9F000F',
                    label: '船積経費',
                },
                {
                    order: 4,
                    value: this.TotalCosts.CostExcludingExpenses.CopyrightFees ?? 0,
                    color: '#44ff44',
                    label: '著作権料',
                },
                {
                    order: 5,
                    value: this.TotalCosts.CostExcludingExpenses.Devan ?? 0,
                    color: '#CA762B',
                    label: 'ﾃﾞﾊﾞﾝ',
                },
                {
                    order: 6,
                    value: this.TotalCosts.CostExcludingExpenses.ECFees ?? 0,
                    color: '#FFC0CB',
                    label: 'EC料',
                },
                {
                    order: 7,
                    value: this.TotalCosts.CostExcludingExpenses.ShippingHandlingGroup ?? 0,
                    color: '#00FFFF',
                    label: '出荷手数料',
                },
                {
                    order: 8,
                    value: this.TotalCosts.CostExcludingExpenses.ShippingFeesGroup ?? 0,
                    color: '#FF5F1F',
                    label: '配送料',
                },
                {
                    order: 9,
                    value: this.TotalCosts.CostExcludingExpenses.SalesCommissionGroup ?? 0,
                    color: '#8B4513',
                    label: '売上ｺﾐｯｼｮﾝ',
                },
                {
                    order: 10,
                    value: this.TotalCosts.CostExcludingExpenses.Mold ?? 0,
                    color: '#ff4444',
                    label: '金型',
                },
                {
                    order: 11,
                    value: this.TotalCosts.CostExcludingExpenses.Prototype ?? 0,
                    color: '#ff44ff',
                    label: '原型',
                },
                {
                    order: 12,
                    value: this.TotalCosts.CostExcludingExpenses.StorageFee ?? 0,
                    color: '#FF8674',
                    label: '保管料',
                },
                {
                    order: 14,
                    value: this.TotalCosts.OtherCost.Commission_Production ?? 0,
                    color: '#C9C0BB',
                    label: '生産ｺﾐｯｼｮﾝ',
                },
                {
                    order: 15,
                    value: this.TotalCosts.OtherCost.PackageDesign ?? 0,
                    color: '#967BB6',
                    label: 'PKGﾃﾞｻﾞｲﾝ',
                },
                {
                    order: 16,
                    value: this.TotalCosts.OtherCost.SamplesCost ?? 0,
                    color: '#8FB31D',
                    label: '見本品費',
                },
                {
                    order: 18,
                    value: this.TotalCosts.OtherCost.WAX ?? 0,
                    color: '#FFB2D0',
                    label: 'WAX',
                },
                {
                    order: 19,
                    value: this.TotalCosts.Profit ?? 0,
                    color: '#ffff00',
                    label: '利益',
                }
            ];

            let chartValuesArray = [];
            let chartValueLabels = [];
            let chartValueColors = [];

            for (let i = 0; i < chartValues.length; i++)
            {
                chartValuesArray.push(chartValues[i].value);
                chartValueLabels.push(chartValues[i].label);
                chartValueColors.push(chartValues[i].color);
            }

            // Series total cost chart
            let data = [{
                values: chartValuesArray,
                labels: chartValueLabels,
                marker: {
                    colors: chartValueColors,
                },
                textinfo: 'percent',
                hoverinfo: 'label+percent',
                type: 'pie',
                hole: .4,
                textposition: 'inside',
                domain: {
                    row: 1,
                    column: 1,
                    x: [0.17, 0.9],
                    y: [0.1, 0.9]
                }
            },
            ];

            let layout = {
                grid: { rows: 1, columns: 1 },
                margin:{
                    l:0,
                    r:0,
                    t:50,
                    b:20
                },
                title: {
                    text: `シリーズ・年間経費`,
                    font: {
                        size: 24,
                        bold: true,
                    }
                },
                showlegend: true,
            };

            this.PieChart_SeriesTotalData = data;
            this.PieChart_SeriesTotalLayout = layout;

            console.log('SERIES TTL', data);

            const allLabels = [
                '関税', '本社費', '仕入額', '船積経費',
                '著作権料', 'ﾃﾞﾊﾞﾝ', 'EC料', '出荷手数料', '配送料', '売上ｺﾐｯｼｮﾝ', '金型', '原型', '保管料',
                '生産ｺﾐｯｼｮﾝ', 'PKGﾃﾞｻﾞｲﾝ', '見本品費', 'WAX', '利益'
            ];

            const allData = [];

            for (let i = 0; i < this.SeriesData.length; i++)
            {
                const s = this.SeriesData[i];

                if (this.PieChart_SeriesFilter.includes(s.series) === false)
                {
                    console.log('Skip series: ', s.series);
                    continue;
                }

                // console.log('Add series data', s);
                
                // data[0].labels.push(s.series);

                // let chartData = {
                //     values: [],
                //     labels: [
                //         'Customs', 'Head Office Exp', 'Purchase Amount', 'Shipping Exp',
                //         'Copyright', 'Devan', 'EC', 'Shipping Handling', 'Shipping Fees', 'Sales Commission', 'Mold', 'Prototype', 'StorageFee',
                //         'Alan', 'Commission Prod', 'Pkg Design', 'Samples', 'Shipping Cases', 'WAX', 'Profit'
                //     ],
                //     type: 'pie',
                //     layout: {
                //         title: s.series,
                //         showlegend: true,
                //     },
                // };
                
                // chartData.values.push([
                //     s.CostIncludingExpenses.Customs, s.CostIncludingExpenses.HeadOfficeExpenses, s.CostIncludingExpenses.PurchaseAmountGroup, s.CostIncludingExpenses.ShippingExpenses,
                //     s.CostExcludingExpenses.CopyrightFees, s.CostExcludingExpenses.Devan, s.CostExcludingExpenses.ECFees, s.CostExcludingExpenses.ShippingHandlingGroup, s.CostExcludingExpenses.ShippingFeesGroup, s.CostExcludingExpenses.SalesCommissionGroup, s.CostExcludingExpenses.Mold, s.CostExcludingExpenses.Prototype, s.CostExcludingExpenses.StorageFee,
                //     s.OtherCost.Commission_Alan, s.OtherCost.Commission_Production, s.OtherCost.PackageDesign, s.OtherCost.SamplesCost, /*s.OtherCost.ShippingCase,*/ s.OtherCost.WAX, s.Profit
                // ]);

                // this.PieCharts_Series.push(chartData);

                allData.push({
                    series: s.series,
                    values: [
                        s.CostIncludingExpenses.Customs, s.CostIncludingExpenses.HeadOfficeExpenses, s.CostIncludingExpenses.PurchaseAmountGroup, s.CostIncludingExpenses.ShippingExpenses,
                        s.CostExcludingExpenses.CopyrightFees, s.CostExcludingExpenses.Devan, s.CostExcludingExpenses.ECFees, s.CostExcludingExpenses.ShippingHandlingGroup, s.CostExcludingExpenses.ShippingFeesGroup, s.CostExcludingExpenses.SalesCommissionGroup, s.CostExcludingExpenses.Mold, s.CostExcludingExpenses.Prototype, s.CostExcludingExpenses.StorageFee,
                        /*s.OtherCost.Commission_Alan,*/ s.OtherCost.Commission_Production, s.OtherCost.PackageDesign, s.OtherCost.SamplesCost, /*s.OtherCost.ShippingCase,*/ s.OtherCost.WAX, s.Profit
                    ]
                });
            }

            const numObjects = allData.length;
            const sqrtNumObjects = Math.sqrt(numObjects);
            const rowsOrColumns = Math.round(sqrtNumObjects);
            const remaining = numObjects - (rowsOrColumns * rowsOrColumns);
            const additional = Math.ceil(remaining / rowsOrColumns);

            const rows = rowsOrColumns + additional;
            const columns = rowsOrColumns;

            let tmpChartObject = [];
            let colCounter = 0;
            let rowCounter = 0;

            // const domainX = 1/columns;
            // const domainY = 1/rows;

            for (let i = 0; i < allData.length; i++)
            {
                // const domainStartX = (colCounter - 1) * domainX;
                // const domainEndX = domainStartX + domainX;
                // const domainStartY = (rows - rowCounter) * domainY;
                // const domainEndY = (domainStartY + domainY); 

                for (let j = 0; j < allData[i].values.length; j++)
                {
                    if (allData[i].values[j] < 0)
                    {
                        allData[i].values[j] *= -1;
                    }
                }

                tmpChartObject.push({
                    values: allData[i].values,
                    labels: allLabels,
                    marker: {
                        colors: chartValueColors
                    },
                    type: 'pie',
                    title: {
                        text: allData[i].series,
                        font: {
                            size: 22,
                            bold: true,
                        }
                    },
                    domain: {
                        row: rowCounter,
                        column: colCounter,
                        // x: [domainStartX, domainEndX],
                        // y: [domainStartY, domainEndY]
                    },
                    textinfo: 'percent',
                    textposition: 'inside',
                    hoverinfo: 'label+percent',
                    
                });

                colCounter++;
                if (colCounter >= columns)
                {
                    colCounter = 0;
                    rowCounter++;
                }
            }

            this.PieChart_SeriesData = tmpChartObject;
            this.PieChart_SeriesLayout = {
                grid: { 
                    rows: rows,
                    columns: columns,
                    pattern: 'independent'
                },
                margin:{
                    l:0,
                    r:0,
                    t:50,
                    b:0
                },
                height: 800,
                paper_bgcolor: 'rgba(0,0,0,0)',
                plot_bgcolor: 'rgba(0,0,0,0)',
                // xaxis: {
                //     gridcolor: 'rgba(200, 200, 200, 0.5)',
                //     gridwidth: 1
                // },
                // yaxis: {
                //     gridcolor: 'rgba(50, 50, 50, 0.5)',
                //     gridwidth: 1
                // }
            }


            // KEEP IT AS REFERENCE IF WE EVER NEED TO MAKE
            // A MORE CUSTOM SELF-MADE PIE-CHART!!
            /*

            const percentages = [];
            let labels = []

            if (this.PieChart_SeriesDataType === 0)
            {
                labels = ['原価算入経費','原価算入外経費','共通経費'];
            }
            else
            {
                labels = ['','',''];
            }

            const pieTest = document.getElementById('PieTest');

            pieTest.style.width = pieTest.parentNode.offsetWidth;
            pieTest.style.height = pieTest.parentNode.offsetHeight;

            const containerCenter = {x: pieTest.parentNode.offsetWidth * 0.5, y: pieTest.parentNode.offsetHeight * 0.5};

            let lastAngle = 0;
            for (let i = 0; i < percentages.length; i++)
            {
                const pieLegend = document.getElementById('PieTestLegend');

                let legendEntry = document.createElement('li');
                pieLegend.append(legendEntry);

                let legendColor = document.createElement('div');
                legendColor.classList.add('Square');
                legendEntry.append(legendColor);

                let legendLabel = document.createElement('label');
                legendLabel.textContent = labels[i];
                legendEntry.append(legendLabel);

                const sliceAngle = percentages[i] * 0.01 * 360;

                let isLargeArc = (sliceAngle > 180) ? 1 : 0;

                // Calculate end angle by adding the current percentage to the start angle
                let endAngle = lastAngle + sliceAngle;

                // Get starting point for the arc
                let startXY = this.GetAngleXY(lastAngle, containerCenter.x, containerCenter.y, 110);
                // Get ending point for the arc
                let endXY = this.GetAngleXY(endAngle, containerCenter.x, containerCenter.y, 110);

                let slice = document.createElementNS("http://www.w3.org/2000/svg", 'path');
                
                if (i === 0)
                {
                    slice.classList.add('CostIncludingSlice', 'Slice');
                    legendColor.style.backgroundColor = 'rgb(228, 223, 236)';
                }
                else if (i === 1)
                {
                    slice.classList.add('CostExcludingSlice', 'Slice');
                    legendColor.style.backgroundColor = 'rgb(253, 233, 217)';
                }
                else
                {
                    slice.classList.add('CostOtherSlice', 'Slice');
                    legendColor.style.backgroundColor = 'rgb(240, 240, 240)';
                }

                slice.setAttribute('d',`M${containerCenter.x},${containerCenter.y} L${startXY.x},${startXY.y} A110,110 0 ${isLargeArc} 1 ${endXY.x},${endXY.y} Z`);
                //slice.style.fill = colors[i];
                let tooltip = document.createElementNS("http://www.w3.org/2000/svg", 'title');
                tooltip.textContent = `${percentages[i]}%`;
                slice.append(tooltip);
                pieTest.append(slice);
                lastAngle = endAngle;

                let bbox = slice.getBBox();
                let center = {
                    x: bbox.x + bbox.width * 0.5,
                    y: bbox.y + bbox.height * 0.5,
                };

                let text = document.createElementNS("http://www.w3.org/2000/svg", 'text');
                text.setAttribute('x', center.x);
                text.setAttribute('y', center.y);
                text.setAttribute('text-anchor', 'middle');
                text.setAttribute('dominant-baseline', 'middle');

                let tspan1 = document.createElementNS("http://www.w3.org/2000/svg", 'tspan');
                tspan1.textContent =  `${labels[i]}:`;  // First line
                tspan1.setAttribute('x', center.x);  // Set the same x position
                tspan1.setAttribute('dy', '0');  // No offset for the first line
                tspan1.style.fontSize = sliceAngle > 30 ? '12px' : '8px';

                let tspan2 = document.createElementNS("http://www.w3.org/2000/svg", 'tspan');
                tspan2.textContent = `${percentages[i]}%`;  // Second line
                tspan2.setAttribute('x', center.x);  // Keep the x position the same
                tspan2.setAttribute('dy', '1.2em');  // Offset by 1.2em to move down
                tspan2.style.fontSize = sliceAngle > 30 ? '12px' : '8px';

                text.append(tspan1);
                text.append(tspan2);

                pieTest.append(text);
            }
            */

            this.$nextTick(()=>{
                this.CreateChartTile('PieChart_Total_Series_Main');
                // this.CreateChartTile('PieChart_Total_Series_Sub');
                this.CreateChartLegendTile('PieChart_Total_Series_Sub');
            });
        },
        CreateChartTile(parentID)
        {
            const p = document.getElementById(parentID);
            if (p===null)
            {
                return;
            }
            
            setTimeout(()=>
            {
                const traces = p.getElementsByClassName('trace');
                
                // const createdBGs = [];
                // let widest = 0;
                // let tallest = 0;
                // let reqOffsetX = 0;
                // let reqOffsetY = 0;

                for (let i = 0; i < traces.length; i++)
                {
                    console.log('create background for trace', traces[i]);
                    traces[i].style.position = 'relative';
                    if (i === 0)
                    {
                        traces[i].parentNode.style.position = 'relative';                    
                    }
    
                    const traceInfo = traces[i].getBBox();
    
                    const bgContainer = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');
                    traces[i].insertBefore(bgContainer, traces[i].firstChild);
    
                    const addWidth = (traceInfo.width * 0.1);
                    const addHeight = (traceInfo.height * 0.1);
                    const offsetX = addWidth * 0.5;
                    const offsetY = addHeight * 0.5;

                    // if (widest < traceInfo.width + addWidth)
                    // {
                    //     widest = traceInfo.width + addWidth;
                    //     reqOffsetX = offsetX;
                    // }

                    // if (tallest < traceInfo.height + addHeight)
                    // {
                    //     tallest = traceInfo.height + addHeight;
                    //     reqOffsetY = offsetY;
                    // }

                    // createdBGs.push(bgContainer);
    
                    bgContainer.style.width = `${traceInfo.width + addWidth}px`;
                    bgContainer.style.height = `${traceInfo.height + addHeight}px`;
                    bgContainer.style.x = `${traceInfo.x - offsetX}px`;
                    bgContainer.style.y = `${traceInfo.y - offsetY}px`;
                    bgContainer.style.overflow = 'visible';
    
                    const bg = document.createElement('div');
                    bgContainer.append(bg);
                    bg.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml');
                    bg.style.width = '100%';
                    bg.style.height = '100%';
                    bg.style.backgroundColor = 'rgba(245, 245, 245, 0.9)';
                    bg.style.borderRadius = '25px';
                    bg.style.boxShadow = 'rgba(30, 30, 30, 0.3) 10px 10px 11px -4px';
                }

                // console.log(`set width: ${widest} height: ${tallest} offX: ${reqOffsetX} offY: ${reqOffsetY}`);

                // for (let i = 0; i < createdBGs.length; i++)
                // {
                //     createdBGs[i].style.width = `${widest}px`;
                //     createdBGs[i].style.height = `${tallest}px`;
                //     createdBGs[i].style.x = `${createdBGs[i].style.x - reqOffsetX}px`;
                //     createdBGs[i].style.y = `${createdBGs[i].style.y - reqOffsetY}px`;
                // }
            }, 500);

            this.CreateChartLegendTile(parentID);
        },
        CreateChartLegendTile(parentID)
        {
            setTimeout(()=>{
                const p = document.getElementById(parentID);
                if (p===null)
                {
                    return;
                }

                const legend = p.getElementsByClassName('legend');
                if (legend.length === 0)
                {
                    return;
                }

                const legendInfo = legend[0].getBBox();

                const bgContainer = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');
                legend[0].firstChild.style.fillOpacity = '0';
                legend[0].insertBefore(bgContainer, legend[0].firstChild);

                const addWidth = (legendInfo.width * 0.1);
                const addHeight = (legendInfo.height * 0.1);
                const offsetX = addWidth * 0.5;
                const offsetY = addHeight * 0.5;

                bgContainer.style.width = `${legendInfo.width + addWidth}px`;
                bgContainer.style.height = `${legendInfo.height + addHeight}px`;
                bgContainer.style.x = `${legendInfo.x - offsetX}px`;
                bgContainer.style.y = `${legendInfo.y - offsetY}px`;
                bgContainer.style.overflow = 'visible';

                const bg = document.createElement('div');
                bgContainer.append(bg);
                bg.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml');
                bg.style.width = '100%';
                bg.style.height = '100%';
                bg.style.backgroundColor = 'rgba(245, 245, 245, 0.9)';
                bg.style.borderRadius = '25px';
                bg.style.boxShadow = 'rgba(30, 30, 30, 0.3) -10px 0px 11px -4px';
            },500);
        },
        UpdatePieChart_BrandCost()
        {
            
            let chartValues = [
                {
                    order: 0,
                    value: this.TotalCosts.CostIncludingExpenses.Customs,
                    color: '#aaaaaa',
                    label: '関税',
                },
                {
                    order: 1,
                    value: this.TotalCosts.CostIncludingExpenses.HeadOfficeExpenses,
                    color: '#3CB371',
                    label: '本社費',
                },
                {
                    order: 2,
                    value: this.TotalCosts.CostIncludingExpenses.PurchaseAmountGroup,
                    color: '#4444ff',
                    label: '仕入額',
                },
                {
                    order: 3,
                    value: this.TotalCosts.CostIncludingExpenses.ShippingExpenses,
                    color: '#9F000F',
                    label: '船積経費',
                },
                {
                    order: 4,
                    value: this.TotalCosts.CostExcludingExpenses.CopyrightFees,
                    color: '#44ff44',
                    label: '著作権料',
                },
                {
                    order: 5,
                    value: this.TotalCosts.CostExcludingExpenses.Devan,
                    color: '#CA762B',
                    label: 'ﾃﾞﾊﾞﾝ',
                },
                {
                    order: 6,
                    value: this.TotalCosts.CostExcludingExpenses.ECFees,
                    color: '#FFC0CB',
                    label: 'EC料',
                },
                {
                    order: 7,
                    value: this.TotalCosts.CostExcludingExpenses.ShippingHandlingGroup,
                    color: '#00FFFF',
                    label: '出荷手数料',
                },
                {
                    order: 8,
                    value: this.TotalCosts.CostExcludingExpenses.ShippingFeesGroup,
                    color: '#FF5F1F',
                    label: '配送料',
                },
                {
                    order: 9,
                    value: this.TotalCosts.CostExcludingExpenses.SalesCommissionGroup,
                    color: '#8B4513',
                    label: '売上ｺﾐｯｼｮﾝ',
                },
                {
                    order: 10,
                    value: this.TotalCosts.CostExcludingExpenses.Mold,
                    color: '#ff4444',
                    label: '金型',
                },
                {
                    order: 11,
                    value: this.TotalCosts.CostExcludingExpenses.Prototype,
                    color: '#ff44ff',
                    label: '原型',
                },
                {
                    order: 12,
                    value: this.TotalCosts.CostExcludingExpenses.StorageFee,
                    color: '#FF8674',
                    label: '保管料',
                },
                {
                    order: 14,
                    value: this.TotalCosts.OtherCost.Commission_Production,
                    color: '#C9C0BB',
                    label: '生産ｺﾐｯｼｮﾝ',
                },
                {
                    order: 15,
                    value: this.TotalCosts.OtherCost.PackageDesign,
                    color: '#967BB6',
                    label: 'PKGﾃﾞｻﾞｲﾝ',
                },
                {
                    order: 16,
                    value: this.TotalCosts.OtherCost.SamplesCost,
                    color: '#8FB31D',
                    label: '見本品費',
                },
                {
                    order: 18,
                    value: this.TotalCosts.OtherCost.WAX,
                    color: '#FFB2D0',
                    label: 'WAX',
                },
                {
                    order: 19,
                    value: this.TotalCosts.Profit,
                    color: '#ffff00',
                    label: '利益',
                }
            ];

            let chartValuesArray = [];
            let chartValueLabels = [];
            let chartValueColors = [];

            for (let i = 0; i < chartValues.length; i++)
            {
                chartValuesArray.push(chartValues[i].value);
                chartValueLabels.push(chartValues[i].label);
                chartValueColors.push(chartValues[i].color);
            }

            // Brand total cost chart
            let data = [{
                values: chartValuesArray,
                labels: chartValueLabels,
                marker: {
                    colors: chartValueColors,
                },
                textinfo: 'percent',
                hoverinfo: 'label+percent',
                type: 'pie',
                hole: .4,
                textposition: 'inside',
                domain: {
                    row: 1,
                    column: 1,
                    x: [0.17, 0.9],
                    y: [0.1, 0.9]
                }
            },
            ];

            let layout = {
                grid: { rows: 1, columns: 1 },
                margin:{
                    l:0,
                    r:0,
                    t:50,
                    b:20
                },
                title: {
                    text: `ブランド・年間経費`,
                    font: {
                        size: 24,
                        bold: true,
                    }
                },
                showlegend: true,
            };

            this.PieChart_BrandTotalData = data;
            this.PieChart_BrandTotalLayout = layout;

            console.log('BRAND TTL', data);

            const allLabels = [
                '関税', '本社費', '仕入額', '船積経費',
                '著作権料', 'ﾃﾞﾊﾞﾝ', 'EC料', '出荷手数料', '配送料', '売上ｺﾐｯｼｮﾝ', '金型', '原型', '保管料',
                '生産ｺﾐｯｼｮﾝ', 'PKGﾃﾞｻﾞｲﾝ', '見本品費', 'WAX', '利益'
            ];

            const allData = [];

            for (let i = 0; i < this.BrandData.length; i++)
            {
                const s = this.BrandData[i];

                // if (this.PieChart_SeriesFilter.includes(s.series) === false)
                // {
                //     continue;
                // }

                allData.push({
                    brand: s.brand,
                    values: [
                        s.CostIncludingExpenses.Customs, s.CostIncludingExpenses.HeadOfficeExpenses, s.CostIncludingExpenses.PurchaseAmountGroup, s.CostIncludingExpenses.ShippingExpenses,
                        s.CostExcludingExpenses.CopyrightFees, s.CostExcludingExpenses.Devan, s.CostExcludingExpenses.ECFees, s.CostExcludingExpenses.ShippingHandlingGroup, s.CostExcludingExpenses.ShippingFeesGroup, s.CostExcludingExpenses.SalesCommissionGroup, s.CostExcludingExpenses.Mold, s.CostExcludingExpenses.Prototype, s.CostExcludingExpenses.StorageFee,
                        s.OtherCost.Commission_Production, s.OtherCost.PackageDesign, s.OtherCost.SamplesCost, s.OtherCost.WAX, s.Profit
                    ]
                });
            }

            const numObjects = allData.length;
            const sqrtNumObjects = Math.sqrt(numObjects);
            const rowsOrColumns = Math.round(sqrtNumObjects);
            const remaining = numObjects - (rowsOrColumns * rowsOrColumns);
            const additional = Math.ceil(remaining / rowsOrColumns);

            const rows = rowsOrColumns + additional;
            const columns = rowsOrColumns;

            let tmpChartObject = [];
            let colCounter = 0;
            let rowCounter = 0;

            for (let i = 0; i < allData.length; i++)
            {
                for (let j = 0; j < allData[i].values.length; j++)
                {
                    if (allData[i].values[j] < 0)
                    {
                        allData[i].values[j] *= -1;
                    }
                }

                tmpChartObject.push({
                    values: allData[i].values,
                    labels: allLabels,
                    marker: {
                        colors: chartValueColors
                    },
                    type: 'pie',
                    title: {
                        text: allData[i].brand,
                        font: {
                            size: 22,
                            bold: true,
                        }
                    },
                    domain: {
                        row: rowCounter,
                        column: colCounter,
                    },
                    textinfo: 'percent',
                    textposition: 'inside',
                    hoverinfo: 'label+percent',
                    
                });

                colCounter++;
                if (colCounter >= columns)
                {
                    colCounter = 0;
                    rowCounter++;
                }
            }

            this.PieChart_BrandData = tmpChartObject;
            this.PieChart_BrandLayout = {
                grid: { rows: rows, columns: columns },
                margin:{
                    l:0,
                    r:0,
                    t:0,
                    b:0
                },
                height: 1000,
            }

            this.$nextTick(()=>{
                this.CreateChartTile('PieChart_Total_Brand_Main');
                // this.CreateChartTile('PieChart_Total_Brand_Sub');
                this.CreateChartLegendTile('PieChart_Total_Brand_Sub');
            });
        },
        UpdatePieChart_FactoryCost()
        {
            let chartValues = [
                {
                    order: 0,
                    value: this.TotalCosts.CostIncludingExpenses.Customs,
                    color: '#aaaaaa',
                    label: '関税',
                },
                {
                    order: 1,
                    value: this.TotalCosts.CostIncludingExpenses.HeadOfficeExpenses,
                    color: '#3CB371',
                    label: '本社費',
                },
                {
                    order: 2,
                    value: this.TotalCosts.CostIncludingExpenses.PurchaseAmountGroup,
                    color: '#4444ff',
                    label: '仕入額',
                },
                {
                    order: 3,
                    value: this.TotalCosts.CostIncludingExpenses.ShippingExpenses,
                    color: '#9F000F',
                    label: '船積経費',
                },
                {
                    order: 4,
                    value: this.TotalCosts.CostExcludingExpenses.CopyrightFees,
                    color: '#44ff44',
                    label: '著作権料',
                },
                {
                    order: 5,
                    value: this.TotalCosts.CostExcludingExpenses.Devan,
                    color: '#CA762B',
                    label: 'ﾃﾞﾊﾞﾝ',
                },
                {
                    order: 6,
                    value: this.TotalCosts.CostExcludingExpenses.ECFees,
                    color: '#FFC0CB',
                    label: 'EC料',
                },
                {
                    order: 7,
                    value: this.TotalCosts.CostExcludingExpenses.ShippingHandlingGroup,
                    color: '#00FFFF',
                    label: '出荷手数料',
                },
                {
                    order: 8,
                    value: this.TotalCosts.CostExcludingExpenses.ShippingFeesGroup,
                    color: '#FF5F1F',
                    label: '配送料',
                },
                {
                    order: 9,
                    value: this.TotalCosts.CostExcludingExpenses.SalesCommissionGroup,
                    color: '#8B4513',
                    label: '売上ｺﾐｯｼｮﾝ',
                },
                {
                    order: 10,
                    value: this.TotalCosts.CostExcludingExpenses.Mold,
                    color: '#ff4444',
                    label: '金型',
                },
                {
                    order: 11,
                    value: this.TotalCosts.CostExcludingExpenses.Prototype,
                    color: '#ff44ff',
                    label: '原型',
                },
                {
                    order: 12,
                    value: this.TotalCosts.CostExcludingExpenses.StorageFee,
                    color: '#FF8674',
                    label: '保管料',
                },
                {
                    order: 14,
                    value: this.TotalCosts.OtherCost.Commission_Production,
                    color: '#C9C0BB',
                    label: '生産ｺﾐｯｼｮﾝ',
                },
                {
                    order: 15,
                    value: this.TotalCosts.OtherCost.PackageDesign,
                    color: '#967BB6',
                    label: 'PKGﾃﾞｻﾞｲﾝ',
                },
                {
                    order: 16,
                    value: this.TotalCosts.OtherCost.SamplesCost,
                    color: '#8FB31D',
                    label: '見本品費',
                },
                {
                    order: 18,
                    value: this.TotalCosts.OtherCost.WAX,
                    color: '#FFB2D0',
                    label: 'WAX',
                },
                {
                    order: 19,
                    value: this.TotalCosts.Profit,
                    color: '#ffff00',
                    label: '利益',
                }
            ];

            let chartValuesArray = [];
            let chartValueLabels = [];
            let chartValueColors = [];

            for (let i = 0; i < chartValues.length; i++)
            {
                chartValuesArray.push(chartValues[i].value);
                chartValueLabels.push(chartValues[i].label);
                chartValueColors.push(chartValues[i].color);
            }

            // Factory total cost chart
            let data = [{
                values: chartValuesArray,
                labels: chartValueLabels,
                marker:{
                  colors: chartValueColors  
                },
                textinfo: 'percent',
                hoverinfo: 'label+percent',
                type: 'pie',
                hole: .4,
                textposition: 'inside',
                domain: {
                    row: 1,
                    column: 1,
                    x: [0.17, 0.9],
                    y: [0.1, 0.9]
                }
            },
            ];

            let layout = {
                grid: { rows: 1, columns: 1 },
                margin:{
                    l:0,
                    r:0,
                    t:50,
                    b:20
                },
                title: {
                    text: `工場・年間経費`,
                    font: {
                        size: 24,
                        bold: true,
                    }
                },
                showlegend: true,
            };

            this.PieChart_FactoryTotalData = data;
            this.PieChart_FactoryTotalLayout = layout;

            console.log('FACTORY TTL', data);

            const allLabels = [
                '関税', '本社費', '仕入額', '船積経費',
                '著作権料', 'ﾃﾞﾊﾞﾝ', 'EC料', '出荷手数料', '配送料', '売上ｺﾐｯｼｮﾝ', '金型', '原型', '保管料',
                '生産ｺﾐｯｼｮﾝ', 'PKGﾃﾞｻﾞｲﾝ', '見本品費', 'WAX', '利益'
            ];

            const allData = [];

            for (let i = 0; i < this.FactoryData.length; i++)
            {
                const s = this.FactoryData[i];

                // if (this.PieChart_SeriesFilter.includes(s.series) === false)
                // {
                //     continue;
                // }

                allData.push({
                    factory: s.factory,
                    values: [
                        s.CostIncludingExpenses.Customs, s.CostIncludingExpenses.HeadOfficeExpenses, s.CostIncludingExpenses.PurchaseAmountGroup, s.CostIncludingExpenses.ShippingExpenses,
                        s.CostExcludingExpenses.CopyrightFees, s.CostExcludingExpenses.Devan, s.CostExcludingExpenses.ECFees, s.CostExcludingExpenses.ShippingHandlingGroup, s.CostExcludingExpenses.ShippingFeesGroup, s.CostExcludingExpenses.SalesCommissionGroup, s.CostExcludingExpenses.Mold, s.CostExcludingExpenses.Prototype, s.CostExcludingExpenses.StorageFee,
                        s.OtherCost.Commission_Production, s.OtherCost.PackageDesign, s.OtherCost.SamplesCost, s.OtherCost.WAX, s.Profit
                    ]
                });
            }

            const numObjects = allData.length;
            const sqrtNumObjects = Math.sqrt(numObjects);
            const rowsOrColumns = Math.round(sqrtNumObjects);
            const remaining = numObjects - (rowsOrColumns * rowsOrColumns);
            const additional = Math.ceil(remaining / rowsOrColumns);

            const rows = rowsOrColumns + additional;
            const columns = rowsOrColumns;

            let tmpChartObject = [];
            let colCounter = 0;
            let rowCounter = 0;

            for (let i = 0; i < allData.length; i++)
            {
                for (let j = 0; j < allData[i].values.length; j++)
                {
                    if (allData[i].values[j] < 0)
                    {
                        allData[i].values[j] *= -1;
                    }
                }

                tmpChartObject.push({
                    values: allData[i].values,
                    labels: allLabels,
                    marker: {
                        colors: chartValueColors
                    },
                    type: 'pie',
                    title: {
                        text: allData[i].factory,
                        font: {
                            size: 22,
                            bold: true,
                        }
                    },
                    domain: {
                        row: rowCounter,
                        column: colCounter,
                    },
                    textinfo: 'percent',
                    textposition: 'inside',
                    hoverinfo: 'label+percent',
                    
                });

                colCounter++;
                if (colCounter >= columns)
                {
                    colCounter = 0;
                    rowCounter++;
                }
            }

            this.PieChart_FactoryData = tmpChartObject;
            this.PieChart_FactoryLayout = {
                grid: { rows: rows, columns: columns },
                margin:{
                    l:0,
                    r:0,
                    t:0,
                    b:0
                },
                height: 800,
            }

            this.$nextTick(()=>{
                this.CreateChartTile('PieChart_Total_Factory_Main');
                // this.CreateChartTile('PieChart_Total_Factory_Sub');
                this.CreateChartLegendTile('PieChart_Total_Factory_Sub');
            });
        },
        UpdateCostPieCharts()
        {
            let newCostIncludingChartData = [{
                    values:[
                        this.TotalCosts.CostIncludingExpenses.PurchaseAmount,
                        this.TotalCosts.CostIncludingExpenses.SamplePurchaseAmount,
                        this.TotalCosts.CostIncludingExpenses.Customs,
                        this.TotalCosts.CostIncludingExpenses.ShippingExpenses,
                        this.TotalCosts.CostIncludingExpenses.HeadOfficeExpenses,
                    ],
                    labels:[
                        '仕入額',
                        '見本仕入額',
                        '関税',
                        '船積経費',
                        '本社費',
                    ],
                    marker:{
                    colors: [
                        '#4444ff',
                        '#9999ff',
                        '#aaaaaa',
                        '#9F000F',
                        '#3CB371'
                    ]  
                    },
                    width: 600,
                    height: 800,
                    domain: {column: 1},
                    hoverinfo: 'label+percent+name',
                    type: 'pie',
                    hole: .4,
                    name: ''
            }];

            let newCostExcludingChartData = [{
                    values:[
                        this.TotalCosts.CostExcludingExpenses.Prototype,
                        this.TotalCosts.CostExcludingExpenses.Mold,
                        this.TotalCosts.CostExcludingExpenses.CopyrightFees,
                        this.TotalCosts.CostExcludingExpenses.Sculptor,
                        this.TotalCosts.CostExcludingExpenses.SalesCommission_PB,
                        this.TotalCosts.CostExcludingExpenses.ECPaymentFees,
                        this.TotalCosts.CostExcludingExpenses.CardFees,
                        this.TotalCosts.CostExcludingExpenses.Shipping_Warehouse,
                        this.TotalCosts.CostExcludingExpenses.Shipping_PB,
                        this.TotalCosts.CostExcludingExpenses.Handling_Warehouse,
                        this.TotalCosts.CostExcludingExpenses.Handling_PB,
                        this.TotalCosts.CostExcludingExpenses.Devan,
                        this.TotalCosts.CostExcludingExpenses.StorageFee
                    ],
                    labels:[
                        '原型',
                        '金型',
                        '著作権料',
                        '原型師',
                        '売上_PB',
                        'IT/PB EC決済手数料',
                        'ｶｰﾄﾞ決済手数料',
                        '出荷手数料_倉庫',
                        '出荷手数料_PB',
                        '配送料_倉庫',
                        '配送料_PB',
                        'ﾃﾞﾊﾞﾝ',
                        '保管料'
                    ],
                    marker:{
                        colors:[
                            '#ff44ff',
                            '#ff4444',
                            '#44ff44',
                            '#8B4513',
                            '#AD6735',
                            '#FFC0CB',
                            '#FFE2ED',
                            '#00FFFF',
                            '#55FFFF',
                            '#FF5F1F',
                            '#FF7F3F',
                            '#CA762B',
                            '#FF8674'
                        ]
                    },
                    domain: {column: 1},
                    hoverinfo: 'label+percent+name',
                    type: 'pie',
                    hole: .4,
                    name: ''
            }];

            let newOtherCostChartData = [{
                    values:[
                        this.TotalCosts.OtherCost.WAX,
                        this.TotalCosts.OtherCost.PackageDesign,
                        // this.TotalCosts.OtherCost.Commission_Alan,
                        this.TotalCosts.OtherCost.Commission_Production,
                        //this.TotalCosts.OtherCost.ShippingCase,
                        this.TotalCosts.OtherCost.SamplesCost
                    ],
                    labels:[
                        'WAX',
                        'PKGﾃﾞｻﾞｲﾝ',
                        // '阿蘭さん固定ｺﾐｯｼｮﾝ',
                        '生産ｺﾐｯｼｮﾝ',
                        //'出荷ｹｰｽ',
                        '見本品費'
                    ],
                    marker:{
                        colors:[
                            '#FFB2D0',
                            '#967BB6',
                            '#C9C0BB',
                            '#8FB31D'
                        ]
                    },
                    domain: {column: 1},
                    hoverinfo: 'label+percent+name',
                    type: 'pie',
                    hole: .4,
                    name: ''
            }];

            this.CostIncludingExpenseChartData = newCostIncludingChartData;
            this.CostExcludingExpenseChartData = newCostExcludingChartData;
            this.OtherCostExpenseChartData = newOtherCostChartData;

            this.CostIncludingPieChartLayout = {
                title: '年間・原価算入経費',
                showlegend: true,
            };

            this.CostExcludingPieChartLayout = {
                title: '年間・原価算入外経費',
                showlegend: true,
            };

            this.OtherCostPieChartLayout = {
                title: '年間・共通経費',
                showlegend: true,
            };
        },
        async GetKeikakumeisaiTotalSalesPerYear()
        {
            this.KeikakumeisaiSalesPerYear = [];

            const products = this.SourceData.keikakumeisaiProducts;

            for (let i = 0; i < products.length; i++)
            {
                const p = products[i];

                const salesDate = new Date(p.salesDate);
                const fullYear = salesDate.getFullYear();

                let yearInfo = null;
                for (let j = 0; j < this.KeikakumeisaiSalesPerYear.length; j++)
                {
                    if (this.KeikakumeisaiSalesPerYear[j].Year === fullYear)
                    {
                        yearInfo = this.KeikakumeisaiSalesPerYear[j];
                        break;
                    }
                }

                if (yearInfo === null)
                {
                    yearInfo = {
                        Year: fullYear,
                        Sales: 0,
                        Profit: 0,
                        Amount: 0,
                        Returns: 0,
                    };

                    this.KeikakumeisaiSalesPerYear.push(yearInfo);
                }

                for (let j = 0; j < p.Data.length; j++)
                {
                    yearInfo.Sales += p.Data[j].sales;
                    yearInfo.Profit += p.Data[j].profit;
                    yearInfo.Amount += p.Data[j].amount;
                    yearInfo.Returns += p.Data[j].numberOfReturns;
                }
            }

            let newData = [{}];
            newData[0].x = [];
            newData[0].y = [];
            newData[0].type = 'bar';

            for (let i = 0; i < this.KeikakumeisaiSalesPerYear.length; i++)
            {
                newData[0].x.push(this.KeikakumeisaiSalesPerYear[i].Year + '_売上');
                newData[0].x.push(this.KeikakumeisaiSalesPerYear[i].Year + '_利益');
                newData[0].y.push(this.KeikakumeisaiSalesPerYear[i].Sales);
                newData[0].y.push(this.KeikakumeisaiSalesPerYear[i].Profit);
            }

            this.data = newData;

            const newLayout = {
                title: '3部売上',
                yaxis:{
                    //tickformat: ',.2r',
                    tickvals: this.data[0].y,
                    ticktext: this.data[0].y.map(value => {
                        if (value >= 100000000)
                        {
                            return `${(value/100000000).toFixed(0)}億`;
                        }
                        else if( value >= 10000 )
                        {
                            return `${(value/1000).toFixed(0)}万`;
                        }
                        else
                        {
                            return value;
                        }
                    }),
                }
            };

            this.layout = newLayout;
        },
        async GetHanbaisakiSales()
        {
            this.HanbaisakiSales = [];

            const salesData = this.SourceData.zaikomeisaiSales;

            for (let i = 0; i < salesData.length; i++)
            {
                const d = salesData[i];
                let hanbaisaki = null;

                for (let j = 0; j < this.HanbaisakiSales.length; j++)
                {
                    if (this.HanbaisakiSales[j].Name === d.name)
                    {
                        hanbaisaki = this.HanbaisakiSales[j];
                        break;
                    }
                }

                if (hanbaisaki === null)
                {
                    hanbaisaki = new Analytics_Distributor(d.name);
                    this.HanbaisakiSales.push(hanbaisaki);
                }

                let info = hanbaisaki.GetSales(d.year, d.month);
                info.Orders += d.orders;
                info.Sales += d.sales;
                info.Profit += d.profit;
            }

            // this.FilteredMinYear = this.SelectedFilterDate[0].year();
            // this.FilteredMinMonth = this.SelectedFilterDate[0].month() + 1;
            // this.FilteredMaxYear = this.SelectedFilterDate[1].year();
            // this.FilteredMaxMonth = this.SelectedFilterDate[1].month() + 1;
            
            this.UpdateHanbaisakiSalesChart();
        },
        UpdateHanbaisakiSalesChart()
        {
            let newSalesChartData = [];
            let newProfitChartData = [];
            let newOrdersChartData = [];

            let highestSales = 0;
            let countSales = 0;
            let ttlSales = 0;
            let avgSales = 0
            let highestProfit = 0;
            let countProfit = 0;
            let ttlProfit = 0;
            let avgProfit = 0;
            let highestOrders = 0;
            let countOrders = 0;
            let ttlOrders = 0;
            let avgOrders = 0;

            for (let i = 0; i < this.HanbaisakiSales.length; i++)
            {
                const h = this.HanbaisakiSales[i];

                if (h.Name === undefined ||
                    (this.FilterDistributors.length > 0 &&
                    this.FilterDistributors.includes(h.Name) === false))
                {
                    continue;
                }

                const xAxis = [];
                for (let j = this.FilteredMinMonth; j <= this.FilteredMaxMonth; j++)
                {
                    xAxis.push(`${j}月`);
                }

                const salesChartData = {
                    x: xAxis,
                    y: [],
                    type: 'bar',
                    name: h.Name
                };

                const profitChartData = {
                    x: xAxis,
                    y: [],
                    type: 'bar',
                    name: h.Name
                };

                const ordersChartData = {
                    x: xAxis,
                    y: [],
                    type: 'bar',
                    name: h.Name
                };
                
                for (let j = 0; j < h.Info.length; j++)
                {
                    salesChartData.y.push(h.Info[j].Sales);
                    profitChartData.y.push(h.Info[j].Profit);
                    ordersChartData.y.push(h.Info[j].Orders);

                    ttlSales += h.Info[j].Sales;
                    ttlProfit += h.Info[j].Profit;
                    ttlOrders += h.Info[j].Orders;

                    countSales++;
                    countProfit++;
                    countOrders++;

                    highestSales = Math.max(highestSales, h.Info[j].Sales);
                    highestProfit = Math.max(highestProfit, h.Info[j].Profit);
                    highestOrders = Math.max(highestOrders, h.Info[j].Orders);
                }

                newSalesChartData.push(salesChartData);
                newProfitChartData.push(profitChartData);
                newOrdersChartData.push(ordersChartData);
            }
            
            avgSales = Math.ceil(ttlSales / countSales);
            avgProfit = Math.ceil(ttlProfit / countProfit);
            avgOrders = Math.ceil(ttlOrders / countOrders);

            this.HanbaisakiSalesChartData = newSalesChartData;
            this.HanbaisakiProfitChartData = newProfitChartData;
            this.HanbaisakiOrdersChartData = newOrdersChartData;

            this.salesChartLayout = {
                title: '販売先・売上',
                yaxis:{
                    //tickformat: ',.2r',
                    tickvals: [0, avgSales, highestSales].sort(this.CompareNumbers),
                    ticktext: [0, avgSales, highestSales].sort(this.CompareNumbers).map(value => this.FormatTraceText(value)),
                }
            }

            this.profitChartLayout = {
                title: '販売先・利益',
                yaxis:{
                    //tickformat: ',.2r',
                    tickvals: [0, avgProfit, highestProfit].sort(this.CompareNumbers),
                    ticktext: [0, avgProfit, highestProfit].sort(this.CompareNumbers).map(value => this.FormatTraceText(value)),
                }
            }
            
            this.ordersChartLayout = {
                title: '販売先・受注数',
                yaxis:{
                    //tickformat: ',.2r',
                    tickvals: [0, avgOrders, highestOrders].sort(this.CompareNumbers),
                    ticktext: [0, avgOrders, highestOrders].sort(this.CompareNumbers).map(value => this.FormatTraceText(value)),
                }
            }
        },
        GetAngleXY(angle, circleX, circleY, radius)
        {
            const result = {x: 0, y: 0};

            const radianAngle = angle * Math.PI / 180;

            result.x = circleX + radius * Math.cos(radianAngle);
            result.y = circleY + radius * Math.sin(radianAngle);

            return result;
        },
        CompareNumbersDesc(a, b)
        {
            return b - a;
        },
        CompareNumbers(a, b) {
          return a - b;
        },
        FormatTraceText(value)
        {
            if (value >= 100000000) {
                return `${(value / 100000000).toFixed(0)}億`;
            } else if (value >= 10000) {
                return `${(value / 10000).toFixed(0)}万`;
            } else {
                return value;
            }
        },
        /*
        ShowCalendar()
        {
            this.show.calendar = !this.show.calendar;

            if (this.show.calendar === true)
            {
                const closer = document.createElement('div');
                closer.id = 'datecloser';
                closer.style.position = 'absolute';
                closer.style.top = '0px';
                closer.style.left = '0px';
                closer.style.width = '100%';
                closer.style.height = '100%';
                document.body.append(closer);
    
                closer.onclick = ()=>{
                    this.ShowCalendar();
                    closer.remove();
                };
            }
            else
            {
                let closer = document.getElementById('datecloser');
                if (closer !== null)
                {
                    closer.remove();
                }
            }
        },
        UpdatedFilterDate(updatedDate)
        {
            this.SelectedFilterDate = updatedDate;
            console.log('filter date updated', this.SelectedFilterDate);

            let target = document.getElementById('SalesHead');
            if (target !== null)
            {
                target.replaceChildren();
            }
            target = document.getElementById('SalesContainerHelper');
            if (target !== null)
            {
                target.replaceChildren();
            }

            this.GetData();
            this.ShowCalendar();
        },
        */
    },
    data()
    {
        return{
            ChartTabOptions:[
                {label: '売上/利益/著作権料/在庫', value: 0, selected: true},
                {label: '受注数/交換対応数', value: 1},
            ],
            SelectedBrandDataType: 0,
            SelectedSeriesDataType: 0,
            SelectedFactoryDataType: 0,
            SelectedDistributorSeriesDataType: 0,
            SelectedDistributorBrandsDataType: 0,
            data: [{
                x: [],
                y: [],
                type:"bar"
            }],
            layout: {
                title: '',
            },
            salesChartLayout:{
                title: '販売先・売上'
            },
            profitChartLayout:{
                title: '販売先・利益',
            },
            ordersChartLayout:{
                title: '販売先・Orders',
            },
            BrandData:[],
            SeriesData:[],
            FactoryData:[],
            DistributorData:[],
            TotalCosts: {},
            BrandChartData:[],
            BrandChartLayout:{},
            SeriesChartData:[],
            SeriesChartLayout:{},
            FactoryChartData:[],
            FactoryChartLayout:{},
            DistributorSeriesChartData:[],
            DistributorSeriesChartLayout:{},
            DistributorBrandsChartData:[],
            DistributorBrandsChartLayout:{},
            config:{
                locale: 'jp',
                displaylogo: false
            },
            SourceData: null,
            show:{
                calendar: false,
            },
            // todayDt: moment(),
            // firstDt: moment('2019-01-01'),
            // SelectedFilterDate: [
            //     moment().startOf('year'),
            //     moment().endOf("year")
            // ],
            KeikakumeisaiSalesPerYear: [],
            HanbaisakiSales: [],
            HanbaisakiSalesChartData: [],
            HanbaisakiProfitChartData: [],
            HanbaisakiOrdersChartData: [],
            Distributors: [],
            FilterDistributors: [],
            FilterYear: [new Date().getFullYear(), new Date().getFullYear()],
            FilterMonth: [1,12],
            MinFilterYear: new Date().getFullYear(),
            MaxFilterYear: new Date().getFullYear(),
            // FilteredMinYear: 1900,
            // FilteredMinMonth: 1,
            // FilteredMaxYear: 9999,
            // FilteredMaxMonth: 12,
            CurrentYear: new Date().getFullYear(),
            CurrentMonth: '1月 - 12月',
            CurrentYearSales: 0,
            CurrentYearProfit: 0,
            YearTTLData: [],
            YearTTLChartLayout: [],
            CostIncludingExpenseChartData: [],
            CostExcludingExpenseChartData: [],
            OtherCostExpenseChartData: [],
            CostIncludingPieChartLayout: {},
            CostExcludingPieChartLayout: {},
            OtherCostPieChartLayout: {},
            PieChart_SelectedSeries: 0,
            PieChart_SelectedSeriesPurpleData: [],
            PieChart_SelectedSeriesOrangeData: [],
            PieChart_SelectedSeriesWhiteData: [],
            PieChart_SeriesOptions: [],
            PieChart_SelectedSeries_Purple_Layout: {},
            PieChart_SelectedSeries_Orange_Layout: {},
            PieChart_SelectedSeries_White_Layout: {},
            PieChart_SeriesTotalData: [],
            PieChart_SeriesTotalLayout: {},
            PieChart_SeriesData: [],
            PieChart_SeriesLayout: {},
            PieChart_SeriesFilter: ['東宝20㎝','東宝30cm', 'ｳﾙﾄﾗ5000', 'ｷﾞｶﾞﾝﾃｨｯｸ','ﾌﾟﾗﾓ', 'DF', '大怪獣20cm', '大怪獣30cm'],
            PieChart_SelectedTotalCostComparison: 0,
            PieChart_TotalCostOptions: [{label:'シリーズ・年間経費'}, {label:'ブランド・年間経費'}, {label:'工場・年間経費'}],
            PieChart_BrandTotalData: [],
            PieChart_BrandTotalLayout: {},
            PieChart_BrandData: [],
            PieChart_BrandLayout: {},
            PieChart_FactoryTotalData: [],
            PieChart_FactoryTotalLayout: {},
            PieChart_FactoryData: [],
            PieChart_FactoryLayout: {},
        }
    },
    watch:{
        FilterDistributors()
        {
            this.UpdateHanbaisakiSalesChart();
        }
    }
}
</script>

<style>
.pie
{
    width: 300px;
    height: 300px;
}
.pie svg
{
    width: 100%;
    height: 100%;
}

.pie svg text
{
    pointer-events: none;
}

.pie svg tspan
{
    pointer-events: none;
}

.PieLegend ul
{
    list-style: none;
    padding: 0px;
}

.PieLegend ul li
{
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    cursor: pointer;
}

.PieLegend .Square
{
    width: 15px;
    height: 15px;
    margin-right: 10px;
}

.Slice
{
    transition: 0.2s;
    -webkit-transition: 0.2s;
    -moz-transition: 0.2s;
}

.CostIncludingSlice
{
    fill: rgb(238, 233, 247);
}

.CostIncludingSlice:hover
{
    fill: rgb(228, 223, 236);
}

.CostExcludingSlice
{
    fill: rgb(253, 242, 234);
}

.CostExcludingSlice:hover
{
    fill: rgb(253, 233, 217);
}

.CostOtherSlice
{
    fill: rgb(245, 245, 245);
}

.CostOtherSlice:hover
{
    fill: rgb(240, 240, 240);
}

.FilterContainer
{
    align-self: center;
    width: 250px;
}

.FilterContainer + .FilterContainer
{
    margin-left: 20px;
}

.ChartContainer
{
    display: flex;
    justify-content: center;
    padding: 0px 25px;
}

.Separator
{
    min-height: 3px;
    margin: 15px 0px;
    background: rgb(135,190,177);
    background: -moz-linear-gradient(180deg, rgba(135,190,177,0) 0%, rgba(206,217,214,1) 50%, rgba(135,190,177,0) 100%);
    background: -webkit-linear-gradient(180deg, rgba(135,190,177,0) 0%, rgba(206,217,214,1) 50%, rgba(135,190,177,0) 100%);
    background: linear-gradient(180deg, rgba(135,190,177,0) 0%, rgba(206,217,214,1) 50%, rgba(135,190,177,0) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#87beb1",endColorstr="#87beb1",GradientType=1); 
}

.ChartContainer .ChartWrapper
{
    flex: 1;
    position: relative;
}

.ChartTabs
{
    padding-left: 10px;
}

.AnalyzeDataSelector
{
    width: 200px;
}

@media screen AND (orientation: portrait)
{
    .ChartContainer
    {
        flex-direction: column;
    }

    .ChartContainer .ChartWrapper
    {
        padding: 0px 5%;
    }
}
</style>